/* EAPS reserve engine — moved out of sections/main-product-bta-reserve.liquid (v38) because Shopify caps section files at 256 KB.
   Booted per section via window.__rbInit. Edit here, not inline. */
(function () {
const init = sectionId => {
const root = document.querySelector('#shopify-section-' + sectionId + ' [data-bta-reserve]');
if (!root || root.dataset.ready === 'true') return;
root.dataset.ready = 'true';
root.closest('.content-for-layout')?.classList.add('content-for-layout--bta-reserve');
// Sticky-stage wiring is shared by every mode (booking, free-hold, retail/gift).
// Defined up here so the retail branch below — which returns early — still gets it.
const syncTravelingLayout = () => {
const stage = root.querySelector('.rb__stage');
const stickyMedia = root.querySelector('.rb__image-card');
const header = document.querySelector('.ea-header');
const headerRect = header ? header.getBoundingClientRect() : null;
const stickyTop = headerRect && headerRect.bottom > 0 ? Math.max(18, Math.ceil(headerRect.bottom + 18)) : 34;
const previewBar = document.getElementById('PBarNextFrameWrapper');
const previewRect = previewBar ? previewBar.getBoundingClientRect() : null;
const stickyBottom = previewRect && previewRect.top < window.innerHeight ? Math.max(0, Math.ceil(window.innerHeight - previewRect.top)) : 0;
root.style.setProperty('--rb-sticky-top', `${stickyTop}px`);
root.style.setProperty('--rb-sticky-bottom', `${stickyBottom}px`);
root.style.removeProperty('--rb-sticky-image-height');
const availableHeight = window.innerHeight - stickyTop - stickyBottom - 24;
const desktop = window.matchMedia('(min-width: 921px)').matches;
const canStick = !!stage && !!stickyMedia && desktop && availableHeight >= 320;
const hero = root.querySelector('.rb__hero');
const booking = root.querySelector('.rb__booking');
const isRetail = root.dataset.rbRetail === 'true';
let stageHeight = 0;
let bookingHeight = 0;
if (stage && booking) {
stageHeight = Math.ceil(stage.getBoundingClientRect().height || 0);
bookingHeight = Math.ceil(booking.getBoundingClientRect().height || 0);
}
const retailLeftIsTaller = isRetail && stageHeight > bookingHeight + 1;
root.classList.toggle('rb--stage-sticky', canStick && !retailLeftIsTaller);
root.classList.toggle('rb--booking-sticky', canStick && retailLeftIsTaller);
// Retail/gift uses the same two-column sticky rule as reservation pages, but it
// has both height orders: sometimes the left details rail is taller than the
// purchase rail. In that case the shorter purchase rail becomes the sticky side
// until its bottom catches the details rail, then both release together.
if (hero && booking && isRetail) {
hero.style.removeProperty('min-height');
}
};
window.addEventListener('resize', syncTravelingLayout);
window.addEventListener('scroll', syncTravelingLayout, { passive: true });
window.addEventListener('load', syncTravelingLayout, { once: true });
root.querySelectorAll('img').forEach(image => image.addEventListener('load', syncTravelingLayout, { once: true }));
requestAnimationFrame(syncTravelingLayout);
if (root.dataset.rbRetail === 'true') {
// Retail / gift mode: native Shopify cart. Reuse the engine's carousel for the image card
// (already initialised below would crash on missing booking nodes), so run a self-contained
// retail controller and skip the BTA booking machinery entirely.
const rroot = root;
const select = rroot.querySelector('[data-retail-select]');
const priceNodes = Array.prototype.slice.call(rroot.querySelectorAll('[data-product-price]'));
const mainImg = rroot.querySelector('[data-rb-main-image]');
const imageCard = rroot.querySelector('.rb__image-card');
const dots = Array.prototype.slice.call(rroot.querySelectorAll('[data-rb-media-dot]'));
const rCfgEl = rroot.querySelector('[data-rb-config]');
let rCfg = {};
try { rCfg = JSON.parse(rCfgEl.textContent) || {}; } catch (_) {}
const variantMap = rCfg.variantMap || {};
let activeVariantId = select ? select.value : (rroot.querySelector('[data-gift-variant]:checked')?.value || String(rCfg.variantId || ''));
let unitCents = Number((variantMap[activeVariantId] || {}).price || rCfg.variantPrice || 0);
const formatMoney = cents => {
const value = (Number(cents) || 0) / 100;
return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: value % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(value);
};
const quantityInput = () => rroot.querySelector('[data-quantity-input]');
const currentQty = () => Math.max(1, parseInt(quantityInput()?.value || '1', 10) || 1);
const syncRetailTotal = () => {
const total = unitCents * currentQty();
priceNodes.forEach(node => { node.textContent = formatMoney(total); });
};
const showRetailImage = (src, index) => {
if (mainImg && src) { mainImg.srcset = ''; mainImg.src = src; }
if (Number.isFinite(index)) {
dots.forEach(d => d.setAttribute('aria-current', Number(d.dataset.index) === index ? 'true' : 'false'));
}
};
if (select) {
select.addEventListener('change', () => {
const opt = select.options[select.selectedIndex];
if (!opt) return;
activeVariantId = opt.value;
unitCents = Number((variantMap[activeVariantId] || {}).price || unitCents);
syncRetailTotal();
if (opt.dataset.image) {
const mediaIndex = rMedia.findIndex(item => item.src === opt.dataset.image || String(item.src).includes(String(opt.dataset.image).split('?')[0]));
showRetailImage(opt.dataset.image, mediaIndex >= 0 ? mediaIndex : undefined);
}
});
}
const giftGroup = rroot.querySelector('[data-gift-amounts]');
if (giftGroup) {
giftGroup.addEventListener('change', event => {
if (!event.target.matches('[data-gift-variant]')) return;
giftGroup.querySelectorAll('.rb__retail-amount').forEach(l => l.classList.remove('is-selected'));
const lbl = event.target.closest('.rb__retail-amount');
if (lbl) lbl.classList.add('is-selected');
activeVariantId = event.target.value;
unitCents = Number((variantMap[activeVariantId] || {}).price || unitCents);
syncRetailTotal();
if (event.target.dataset.image) showRetailImage(event.target.dataset.image);
});
}
rroot.querySelectorAll('[data-quantity-control]').forEach(control => {
const input = control.querySelector('[data-quantity-input]');
if (!input) return;
const setQ = next => {
const min = parseInt(input.getAttribute('min') || '1', 10);
let v = parseInt(next, 10);
if (isNaN(v) || v < min) v = min;
input.value = v;
syncRetailTotal();
};
control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => setQ((parseInt(input.value, 10) || 1) - 1));
control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => setQ((parseInt(input.value, 10) || 1) + 1));
input.addEventListener('change', () => setQ(input.value));
});
rroot.querySelectorAll('[data-gift-recipient]').forEach(rootEl => {
const toggle = rootEl.querySelector('[data-gift-recipient-toggle]');
const fields = rootEl.querySelector('[data-gift-recipient-fields]');
const inputs = rootEl.querySelectorAll('[data-gift-recipient-field]');
const email = rootEl.querySelector('[data-gift-recipient-email]');
const offset = rootEl.querySelector('[data-gift-recipient-offset]');
const sync = () => {
const on = !!(toggle && toggle.checked);
if (fields) fields.hidden = !on;
inputs.forEach(i => { i.disabled = !on; });
if (email) email.required = on;
if (offset && on) offset.value = String(new Date().getTimezoneOffset());
};
if (toggle) toggle.addEventListener('change', sync);
sync();
});
// Learn-more smooth scroll reuses the engine link; carousel arrows/dots are wired by the
// shared carousel init that follows, which is null-safe. Bail out of BTA booking init.
// Wire the shared image-card carousel for retail (multi-image products).
const rMedia = rCfg.media || [];
const rPrev = rroot.querySelector('[data-rb-carousel-prev]');
const rNext = rroot.querySelector('[data-rb-carousel-next]');
let rIdx = 0;
const rSetMedia = i => {
if (!rMedia.length || !mainImg) return;
rIdx = ((Number(i) || 0) % rMedia.length + rMedia.length) % rMedia.length;
const item = rMedia[rIdx];
if (item && item.src) { mainImg.srcset = ''; mainImg.src = item.src; mainImg.alt = item.alt || ''; }
dots.forEach(d => d.setAttribute('aria-current', Number(d.dataset.index) === rIdx ? 'true' : 'false'));
};
if (rPrev) rPrev.addEventListener('click', () => rSetMedia(rIdx - 1));
if (rNext) rNext.addEventListener('click', () => rSetMedia(rIdx + 1));
dots.forEach(d => d.addEventListener('click', () => rSetMedia(Number(d.dataset.index || 0))));
if (imageCard && rMedia.length > 1) {
let startX = 0;
let startY = 0;
imageCard.addEventListener('touchstart', event => {
const touch = event.changedTouches && event.changedTouches[0];
if (!touch) return;
startX = touch.clientX;
startY = touch.clientY;
}, { passive: true });
imageCard.addEventListener('touchmove', event => {
const touch = event.changedTouches && event.changedTouches[0];
if (!touch) return;
const dx = touch.clientX - startX;
const dy = touch.clientY - startY;
if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.15 && event.cancelable) event.preventDefault();
}, { passive: false });
imageCard.addEventListener('touchend', event => {
const touch = event.changedTouches && event.changedTouches[0];
if (!touch) return;
const dx = touch.clientX - startX;
const dy = touch.clientY - startY;
if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.25) rSetMedia(rIdx + (dx < 0 ? 1 : -1));
}, { passive: true });
}
syncRetailTotal();
return;
}
const config = JSON.parse(root.querySelector('[data-rb-config]').textContent);
const form = root.querySelector('[data-rb-form]');
const sessionModal = root.querySelector('[data-rb-session-modal]');
const sessionList = root.querySelector('[data-rb-session-list]');
const sessionFoot = root.querySelector('[data-rb-session-foot]');
const openSessions = root.querySelector('[data-rb-open-sessions]');
const applySessions = root.querySelector('[data-rb-apply-sessions]');
const sessionTitle = root.querySelector('[data-rb-session-title]');
const sessionMeta = root.querySelector('[data-rb-session-meta]');
const sessionCount = root.querySelector('[data-rb-session-count]');
const projectList = root.querySelector('[data-rb-project-list]');
const nightGroup = root.querySelector('[data-rb-night-group]');
const nightOptions = root.querySelector('[data-rb-night-options]');
let selectedNightKey = '';
let eventNights = [];
const mainImage = root.querySelector('[data-rb-main-image]');
const imageCard = root.querySelector('.rb__image-card');
const mobileMediaCaption = root.querySelector('[data-rb-mobile-media-caption]');
const mobileMediaTitle = root.querySelector('[data-rb-mobile-media-title]');
const mobileMediaMeta = root.querySelector('[data-rb-mobile-media-meta]');
const carouselPrev = root.querySelector('[data-rb-carousel-prev]');
const carouselNext = root.querySelector('[data-rb-carousel-next]');
const carouselDots = [...root.querySelectorAll('[data-rb-media-dot]')];
const availabilityNote = root.querySelector('[data-rb-availability-note]');
const peopleEl = root.querySelector('[data-rb-people]');
const qtyOut = root.querySelector('[data-rb-qty]');
const qtyCap = root.querySelector('[data-rb-qty-cap]');
const qtyNote = root.querySelector('[data-rb-qty-note]');
const minus = root.querySelector('[data-rb-minus]');
const plus = root.querySelector('[data-rb-plus]');
const submit = root.querySelector('[data-rb-submit]');
const buynow = root.querySelector('[data-rb-buynow]');
const shipCard = root.querySelector('[data-rb-ship-card]');
const shipChoice = root.querySelector('[data-rb-ship-choice]');
const shipCheckbox = root.querySelector('[data-rb-ship-checkbox]');
const shipNote = root.querySelector('[data-rb-ship-note]');
const status = root.querySelector('[data-rb-status]');
const totalLabel = root.querySelector('[data-rb-total-label]');
const total = root.querySelector('[data-rb-total]');
const stageTitle = root.querySelector('[data-rb-stage-title]');
const stageNote = root.querySelector('[data-rb-stage-note]');
const waiverModal = root.querySelector('[data-rb-waiver-modal]');
const waiverScroll = root.querySelector('[data-rb-waiver-scroll]');
const waiverName = root.querySelector('[data-rb-waiver-name]');
const waiverSubmit = root.querySelector('[data-rb-waiver-submit]');
const waiverStatus = root.querySelector('[data-rb-waiver-status]');
const waiverHelp = root.querySelector('[data-rb-waiver-help]');
const policyAccept = root.querySelector('[data-rb-policy-accept]');
const waiverCardEl = root.querySelector('[data-rb-waiver-card]');
const missingEl = root.querySelector('[data-rb-missing]');
const bookingHeadingEl = root.querySelector('.rb__booking-frame h2');
const bookingHeadingDefault = bookingHeadingEl ? bookingHeadingEl.textContent : '';
const eventWaitlistCard = root.querySelector('[data-rb-event-waitlist]');
const eventWaitlistName = root.querySelector('[data-rb-event-waitlist-name]');
const eventWaitlistEmail = root.querySelector('[data-rb-event-waitlist-email]');
const eventWaitlistPhone = root.querySelector('[data-rb-event-waitlist-phone]');
const venueText = root.querySelector('[data-rb-venue]');
const venueAddress = root.querySelector('[data-rb-venue-address]');
const studioOptions = root.querySelector('[data-rb-studio-options]');
const dateInput = root.querySelector('[data-rb-date]');
const dateSelect = root.querySelector('[data-rb-date-select]');
const calendarControl = root.querySelector('[data-rb-calendar-control]');
const calendarField = calendarControl ? calendarControl.closest('.rb__field-group--sessions') : null;
const learnLink = root.querySelector('[data-rb-learn-link]');
const learnPanel = root.querySelector(`#learn-${sectionId}`);
let btaProduct = null;
let sessions = [];
let selectedIds = new Set();
let projectQuantities = {};
let miniSeriesMirror = false;
const minQuantity = () => Math.max(1, Number(config.minQuantity || 1));
const peopleCount = () => (config.leadOnly ? 1 : quantity);
const groupExtras = () => Math.max(0, quantity - minQuantity());
const groupBaseId = () => Number((config.groupBase || {}).id || config.variantId);
const groupAddonId = () => Number((config.groupAddon || {}).id || 0);
const groupTotalCents = () => config.perSeat ? Number((config.groupBase || {}).price || 0) * quantity : Number((config.groupBase || {}).price || 0) + groupExtras() * Number((config.groupAddon || {}).price || 0);
const groupBreakdown = () => {
if (config.perSeat) return `${quantity} × ${(config.groupBase || {}).money || money(Number((config.groupBase || {}).price || 0))}`;
const extras = groupExtras();
const base = `${(config.groupBase || {}).money || money(Number((config.groupBase || {}).price || 0))} for ${minQuantity()}`;
return extras ? `${base} + ${extras} × ${(config.groupAddon || {}).money || ''}` : base;
};
const guestAgeOptions = () => ['Adult'].concat(Array.from({ length: 13 }, (_, i) => String(i + 5)));
let quantity = minQuantity();
let activeMediaIndex = 0;
let selectedLocationId = '';
let availableDateChoices = [];
const requestedStudio = (() => {
try {
return (new URLSearchParams(window.location.search).get('studio') || '').toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-|-$/g, '');
} catch (_) { return ''; }
})();
let calendarPicked = false;
let waiverAccepted = null;
let waiverLoaded = false;
let waiverScrolled = false;
let selectedFhVariantId = config.freeHold ? String(config.variantId) : '';
const fhGroups = root.querySelector('[data-rb-fh-groups]');
const themeNotes = {
ocean: 'Sea creatures, shoreline textures, and cool blue glazing ideas.',
animals: 'Animal forms, creature characters, and playful surface design.',
food: 'Clay food, color, pattern, and pieces that feel good enough to eat.',
world: 'Global patterns, landmarks, maps, and travel-inspired studio work.',
science: 'Experiments, texture, color reactions, and hands-on material play.',
fairytale: 'Castles, creatures, story objects, and a little studio magic.',
pop: 'Bright icons, bold color, music, games, and pop-culture clay.',
space: 'Planets, rockets, constellations, and cosmic color.'
};
const esc = value => String(value ?? '').replace(/[&<>'"]/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[c]));
const pluralize = (count, noun) => noun === 'person' ? `${count} ${Number(count) === 1 ? 'person' : 'people'}` : `${count} ${noun}${Number(count) === 1 ? '' : 's'}`;
const quantityNoun = () => config.quantityNoun || (config.isCamp ? 'camper' : 'person');
const kidMode = () => !!(config.isCamp || config.isKids);
const kidLabel = () => config.isKids ? 'Student' : 'Camper';
const kidAgeList = () => (config.isKids && config.kidAges) ? String(config.kidAges).split(',').map(a => Number(a)).filter(Boolean) : [5,6,7,8,9,10,11,12];
const quantityLabel = () => config.quantityLabel || (quantityNoun().charAt(0).toUpperCase() + quantityNoun().slice(1));
const money = cents => {
try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100); }
catch (_) { return '$' + (((Number(cents) || 0) / 100).toFixed(2)); }
};
const setStatus = (message, tone = '') => {
status.textContent = message || '';
status.dataset.tone = tone;
};
const parseDate = value => {
if (!value) return null;
if (value instanceof Date) return value;
const str = String(value);
const isoish = str.includes('T') ? str : str.replace(' ', 'T') + ':00.000Z';
const date = new Date(isoish);
return Number.isNaN(date.getTime()) ? null : date;
};
const fmtDate = iso => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: config.timeZone }).format(new Date(iso));
const addDays = (date, days) => new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
const toDateValue = date => {
const d = new Date(date);
d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
return d.toISOString().slice(0, 10);
};
const dateValueInZone = iso => {
const parts = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: config.timeZone }).formatToParts(new Date(iso));
const get = type => parts.find(part => part.type === type)?.value;
return `${get('year')}-${get('month')}-${get('day')}`;
};
const fmtDateValue = value => {
const [year, month, day] = String(value || '').split('-').map(Number);
if (!year || !month || !day) return 'Pick a date';
const noonUtc = new Date(Date.UTC(year, month - 1, day, 16, 0, 0));
return new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: config.timeZone }).format(noonUtc);
};
const fmtRange = session => {
if (!session.start || !session.finish) return 'Date TBA';
const a = fmtDate(session.start);
const b = fmtDate(session.finish);
return a === b ? a : `${a}-${b}`;
};
const fmtDayLong = iso => iso ? new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric', timeZone: config.timeZone }).format(new Date(iso)) : '';
const fmtTime = iso => iso ? new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZone: config.timeZone }).format(new Date(iso)) : '';
const fmtLong = iso => iso ? new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: config.timeZone }).format(new Date(iso)) : '';
const cleanName = name => {
const raw = String(name || '').replace(/[–—]/g, '-').trim();
if (!config.isCamp) return raw || 'Session';
return raw.split(':').slice(1).join(':').trim() || raw || 'Camp week';
};
const sessionNumber = name => ((String(name || '').match(/Week\s+(\d+)/i) || [,''])[1]);
const themeKey = name => cleanName(name).toLowerCase().replace(/[^a-z]+/g, ' ').trim().split(' ')[0] || 'camp';
const projectQuantity = session => Number(projectQuantities[session?.key] || 0);
const totalProjectQuantity = () => sessions.reduce((sum, session) => sum + projectQuantity(session), 0);
const selectedSessions = () => sessions.filter(session => config.projectQuantityMode ? projectQuantity(session) > 0 : selectedIds.has(session.key));
const inlineSessionMode = () => config.recurringMode || (!config.projectQuantityMode && !config.allowMultiple && sessions.length > 0 && sessions.length <= 4);
const priceCents = () => Number(config.variantPrice) || 0;
const btaLocations = () => btaProduct?.locations || [];
const normalizeLocationName = value => {
const raw = String(value || '').trim();
const lower = raw.toLowerCase();
if (lower.includes('rockville')) return 'EAPS Rockville Centre';
if (lower.includes('long beach')) return lower.includes('eaps') ? raw : 'EAPS Long Beach';
if (lower.includes('garden city')) return lower.includes('eaps') ? raw : 'EAPS Garden City';
return raw || 'EAPS Long Beach';
};
const locationSlug = value => normalizeLocationName(value).toLowerCase().replace(/^eaps\s+/, '').replace(/[^a-z]+/g, '-').replace(/^-|-$/g, '');
const defaultLocation = () => {
const match = selectedLocationId ? btaLocations().find(item => String(item.id) === String(selectedLocationId)) : null;
return normalizeLocationName((match || btaLocations()[0] || {}).name || config.venue || 'EAPS Long Beach');
};
const locationAddress = value => {
const lower = String(value || '').toLowerCase();
if (lower.includes('rockville')) return 'Sunrise Highway, Rockville Centre, New York 11570';
if (lower.includes('garden city')) return '659 Franklin Avenue, Garden City, New York 11530';
return '162 West Park Avenue, Long Beach, New York 11561';
};
const eventVenueAddressFor = name => {
const lower = String(name || '').toLowerCase();
if (lower.includes('bright eye')) return '50 W Park Ave, Long Beach, New York 11561';
if (lower.includes('garden city')) return '659 Franklin Avenue, Garden City, New York 11530';
if (lower.includes('long beach')) return '162 West Park Avenue, Long Beach, New York 11561';
return '';
};
const eventVenueName = () => {
const night = eventNights.find(item => item.key === selectedNightKey) || eventNights[0];
const id = night?.locationId || (sessions[0] || {}).locationId;
const location = btaLocations().find(item => String(item.id) === String(id));
const raw = String(location?.name || '').trim();
if (raw && !/^eaps\s/i.test(raw) && !/^(long beach|garden city)$/i.test(raw)) return raw;
return 'Bright Eye Beer Co';
};
const sessionLocationName = session => {
if (config.isEventProduct) return eventVenueName();
const id = session?.locationId;
const location = btaLocations().find(item => String(item.id) === String(id));
return normalizeLocationName((location && location.name) || defaultLocation());
};
const shipModeActive = () => !config.freeHold && ['optional', 'location_aware', 'required'].includes(String(config.shipMode || '').toLowerCase()) && Number(config.shipVariantSmall || 0) > 0;
const gardenCityName = value => /garden[\s-]*city/i.test(String(value || ''));
const gardenCitySession = session => gardenCityName(sessionLocationName(session));
const studioVariantFor = value => {
const map = config.studioVariantMap || {};
const name = String(value || '').toLowerCase();
if (!name) return null;
let hit = null;
Object.keys(map).forEach(k => { if (name.includes(k) || k.includes(name)) hit = map[k]; });
return hit;
};
const sessionCartVariantId = session => (config.leadOnly ? groupBaseId() : Number(studioVariantFor(sessionLocationName(session)) || config.variantId));
const selectedStudioVariantExternalId = () => {
const location = btaLocations().find(item => String(item.id) === String(selectedLocationId));
return studioVariantFor(normalizeLocationName(location?.name || ''));
};
const pickAvailabilityForSlot = slot => {
const list = slot.availability || [];
if (config.leadOnly) return list.find(av => String(av.external_id) === String(groupBaseId())) || list[0];
if (list.length < 2) return list[0];
const term = slot.term_id ? ((btaProduct?.terms || []).find(t => String(t.id) === String(slot.term_id)) || {}) : {};
const locId = term.location_id || slot.location_id || selectedLocationId;
const location = btaLocations().find(item => String(item.id) === String(locId));
const mapped = studioVariantFor(normalizeLocationName(location?.name || ''));
if (!mapped) return list[0];
return list.find(av => String(av.external_id) === String(mapped)) || list[0];
};
const shipMandatory = selected => {
if (!shipModeActive()) return false;
const mode = String(config.shipMode || '').toLowerCase();
if (mode === 'required') return true;
if (mode !== 'location_aware') return false;
if (selected && selected.length) return selected.some(gardenCitySession);
const location = btaLocations().find(item => String(item.id) === String(selectedLocationId));
return gardenCityName(normalizeLocationName(location?.name || ''));
};
const shipApplies = selected => {
if (!shipModeActive()) return false;
if (shipMandatory(selected)) return true;
return Boolean(shipCheckbox && shipCheckbox.checked);
};
const shipPartySize = (selected, people) => {
try {
if (config.projectQuantityMode) {
let total = 0;
(selected || []).forEach(session => {
const group = people && people[session.key];
total += (Array.isArray(group) && group.length) ? group.length : (Number(projectQuantity(session)) || 0);
});
return total;
}
if (config.leadOnly) return Number(quantity) || 0;
if (Array.isArray(people) && people.length) return people.length;
return Number(quantity) || 0;
} catch (err) {
return 0;
}
};
const shipVariantForCount = (count, gc) => {
const small = Number((gc && config.shipVariantSmallGc) || config.shipVariantSmall || 0);
const medium = Number((gc && config.shipVariantMediumGc) || config.shipVariantMedium || 0);
const large = Number((gc && config.shipVariantLargeGc) || config.shipVariantLarge || 0);
const n = Number(count);
if (!Number.isFinite(n) || n < 1) return small;
if (n <= 2) return small;
if (n <= 6) return medium || small;
return large || small;
};
const shippingCartItem = (selected, people) => {
if (!shipApplies(selected)) return null;
const shipVariant = shipVariantForCount(shipPartySize(selected, people), shipMandatory(selected));
if (!shipVariant) return null;
const properties = { 'For booking': config.shipBookingLabel || config.productTitle || '' };
if (shipMandatory(selected)) properties['Required'] = 'Garden City fired pieces ship to you \u2014 packing\u2019s included';
return { id: shipVariant, quantity: 1, properties };
};
const syncShipUI = selected => {
if (!shipCard) return;
if (!shipModeActive()) { shipCard.hidden = true; return; }
const mandatory = shipMandatory(selected);
shipCard.hidden = false;
if (shipChoice) shipChoice.hidden = mandatory;
if (shipNote) {
shipNote.hidden = !mandatory;
if (mandatory && String(config.shipMode || '').toLowerCase() !== 'location_aware') shipNote.textContent = 'Your pieces ship to you \u2014 add your address at checkout.';
}
};
const syncVenueLabelCore = () => {
if (config.isEventProduct) {
config.venue = eventVenueName();
config.venueAddress = eventVenueAddressFor(config.venue) || '50 W Park Ave, Long Beach, New York 11561';
if (venueText) venueText.textContent = config.venue;
if (venueAddress) venueAddress.textContent = config.venueAddress;
return;
}
if (config.recurringMode && !selectedLocationId && btaLocations().length > 1) {
if (venueText) venueText.textContent = 'Choose a studio';
if (venueAddress) venueAddress.textContent = '';
return;
}
config.venue = defaultLocation();
config.venueAddress = locationAddress(config.venue);
if (venueText) venueText.textContent = config.venue;
if (venueAddress) venueAddress.textContent = config.venueAddress;
};
const syncStudioGate = () => {
const needsStudio = !config.isEventProduct && config.recurringMode && !selectedLocationId && btaLocations().length > 1;
root.classList.toggle('rb--no-studio', needsStudio);
if (bookingHeadingEl) bookingHeadingEl.textContent = needsStudio ? 'Choose your studio' : bookingHeadingDefault;
};
const syncVenueLabel = () => { syncVenueLabelCore(); syncStudioGate(); };
const renderStudioOptions = () => {
if (!studioOptions || !config.recurringMode) return;
const locations = btaLocations();
if (!locations.length) return;
if (!selectedLocationId && locations.length === 1) selectedLocationId = String(locations[0].id || '');
if (locations.length === 1) { studioOptions.hidden = true; studioOptions.innerHTML = ''; return; }
studioOptions.hidden = false;
studioOptions.innerHTML = locations.map(location => {
const name = normalizeLocationName(location.name);
return `<button type="button" class="rb__studio-option" data-rb-location="${esc(location.id)}" aria-pressed="${String(location.id) === String(selectedLocationId) ? 'true' : 'false'}"><strong>${esc(name)}</strong><span>${esc(locationAddress(name))}</span></button>`;
}).join('');
studioOptions.querySelectorAll('[data-rb-location]').forEach(button => button.addEventListener('click', async () => {
if (button.dataset.rbLocation === selectedLocationId) return;
selectedLocationId = button.dataset.rbLocation;
selectedIds.clear();
calendarPicked = false;
if (dateInput) dateInput.value = '';
if (dateSelect) dateSelect.value = '';
syncVenueLabel();
renderStudioOptions();
setStatus('Loading sessions...');
try {
await fetchFrames();
renderSessions();
updateSummary();
setStatus('');
} catch (err) {
sessions = [];
renderSessions();
updateSummary();
setStatus(err.message || 'Unable to load sessions for that studio.', 'error');
}
}));
};
const fetchBtaProduct = async () => {
const url = new URL('/apps/bookthatapp/api/v1/products', window.location.origin);
if (config.btaProductId) {
url.searchParams.set('per', '250');
} else {
url.searchParams.set('handle', config.productHandle);
url.searchParams.set('per', '1');
}
url.searchParams.set('shop', config.btaShop);
const res = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
if (!res.ok) throw new Error('Could not load online reservation data.');
const data = await res.json();
btaProduct = config.btaProductId
? ((data.products || []).find(item => String(item.id) === String(config.btaProductId)) || null)
: ((data.products || [])[0] || null);
if (!btaProduct) throw new Error('Online reservation is not configured for this product yet.');
if (config.recurringMode && !selectedLocationId) {
if (config.freeHold && config.locationId) {
selectedLocationId = String(config.locationId);
} else {
const locs = btaLocations();
const requested = requestedStudio ? locs.find(item => locationSlug(item.name) === requestedStudio) : null;
/* Preselect only a deep-linked studio (?studio=) or a sole location — when several studios host this, the choice belongs to the guest */
selectedLocationId = String((requested || (locs.length === 1 ? locs[0] : {})).id || '');
}
}
syncVenueLabel();
renderStudioOptions();
};
const buildSessionsFromFrames = frames => {
const grouped = new Map();
frames.forEach(frame => (frame.timeslots || []).forEach(slot => {
const termId = slot.term_id || '';
const avList = config.isEventProduct ? (slot.availability || []) : [pickAvailabilityForSlot(slot) || {}];
avList.forEach(av => {
const key = termId ? `term-${termId}` : `slot-${slot.start}-${slot.finish}-${av.external_id || config.variantId}`;
const term = termId ? ((btaProduct.terms || []).find(t => String(t.id) === String(termId)) || {}) : {};
const item = grouped.get(key) || {
key,
termId: termId || null,
name: term.name || slot.title || slot.name || (config.isCamp ? `Week ${grouped.size + 1}` : 'Session'),
start: slot.start,
finish: slot.finish,
available: Number(av.available || 0),
status: Number(av.status || 0),
externalId: av.external_id || config.variantId,
variantId: av.variant_id || null,
locationId: term.location_id || slot.location_id || ((btaProduct.locations || [])[0] || {}).id || null,
slots: []
};
if (slot.start && (!item.start || new Date(slot.start) < new Date(item.start))) item.start = slot.start;
if (slot.finish && (!item.finish || new Date(slot.finish) > new Date(item.finish))) item.finish = slot.finish;
item.available = Math.min(Number(item.available || 0), Number(av.available || 0));
item.status = item.status === 1 && Number(av.status) === 1 ? 1 : Number(av.status || item.status);
item.externalId = av.external_id || item.externalId || config.variantId;
item.variantId = av.variant_id || item.variantId;
item.slots.push(slot);
grouped.set(key, item);
});
}));
return Array.from(grouped.values());
};
const buildFallbackSessions = () => {
return (btaProduct.terms || []).map((term, index) => {
const startDate = parseDate(term.start_date || term.starts_at || term.start);
const finishDate = parseDate(term.finish_date || term.finishes_at || term.finish || term.start_date);
return {
key: `term-${term.id || index}`,
termId: term.id || null,
name: term.name || (config.isCamp ? `Week ${index + 1}` : `Session ${index + 1}`),
start: startDate ? startDate.toISOString() : '',
finish: finishDate ? finishDate.toISOString() : '',
available: 0,
status: 0,
externalId: ((btaProduct.variants || [])[0] || {}).external_id || config.variantId,
variantId: ((btaProduct.variants || [])[0] || {}).id || null,
locationId: term.location_id || ((btaProduct.locations || [])[0] || {}).id || null,
slots: []
};
});
};
const selectedFhGroupTitle = () => (config.variantMap[String(selectedFhVariantId)] || {}).title || '';
const selectedBtaVariant = () => {
const localTitle = normalizeText(selectedFhGroupTitle());
const variants = btaProduct?.variants || [];
return variants.find(variant => normalizeText(variant.name || variant.title || '') === localTitle) || variants[0] || {};
};
const btaBlockIntervalMinutes = () => {
const durationMinutes = Number(btaProduct?.duration?.duration || 0) / 60;
const lagMinutes = Number(btaProduct?.lag_time || 0);
const total = durationMinutes + lagMinutes;
return Number.isFinite(total) && total > 0 ? Math.ceil(total) : 60;
};
const fetchRecurringBlocks = async () => {
const btaVariant = selectedBtaVariant();
const externalId = config.freeHold ? String(btaVariant.external_id || selectedFhVariantId || config.variantId) : String(selectedStudioVariantExternalId() || btaVariant.external_id || config.variantId);
const datePicked = !!dateInput?.value;
let start = new Date();
let finish = addDays(start, 90);
const url = new URL('/apps/bookthatapp/api/v1/blocks', window.location.origin);
url.searchParams.set('external_id', externalId);
url.searchParams.set('interval', String(btaBlockIntervalMinutes()));
url.searchParams.set('start', start.toISOString());
url.searchParams.set('finish', finish.toISOString());
if (selectedLocationId) url.searchParams.append('location_ids[]', String(selectedLocationId));
url.searchParams.set('shop', config.btaShop);
const res = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
if (!res.ok) {
const text = await res.text().catch(() => '');
if (res.status === 422 && text.toLowerCase().includes('scheduled products')) {
sessions = [];
return;
}
throw new Error('Could not load sessions.');
}
const data = await res.json();
const allSessions = [];
(data.blocks || []).forEach((block, blockIndex) => (block.timeslots || []).forEach((slot, slotIndex) => {
const available = Number(slot.available || 0);
const status = Number(slot.status || 0);
if (status !== 1 || available <= 0) return;
allSessions.push({
key: `slot-${slot.start}-${slot.finish}-${selectedLocationId || slot.location_id || blockIndex}-${slotIndex}`,
termId: null,
name: config.freeHold ? (config.experienceLabel || 'Open Studio') : 'Wheel Wind Down',
start: slot.start,
finish: slot.finish,
available,
status,
externalId,
variantId: btaVariant.id || null,
locationId: selectedLocationId || slot.location_id || null,
slots: [slot]
});
}));
availableDateChoices = buildAvailableDateChoices(allSessions);
sessions = datePicked ? allSessions.filter(session => dateValueInZone(session.start) === dateInput.value) : allSessions;
sessions.sort((a, b) => new Date(a.start || 0) - new Date(b.start || 0));
};
const fetchFrames = async () => {
if (config.freeHold) { await fetchRecurringBlocks(); return; }
const url = new URL('/apps/bookthatapp/api/v1/frames', window.location.origin);
const start = (config.recurringMode || config.isEventProduct) ? new Date().toISOString() : config.seasonStart;
const finish = config.recurringMode ? addDays(new Date(), 180).toISOString() : (config.isEventProduct ? addDays(new Date(), 365).toISOString() : config.seasonFinish);
url.searchParams.set('external_id', String(config.productId));
url.searchParams.set('start', start);
url.searchParams.set('finish', finish);
url.searchParams.set('resource_id', '');
url.searchParams.set('is_events_list', 'true');
url.searchParams.set('shop', config.btaShop);
const res = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
if (!res.ok) throw new Error('Could not load availability.');
const data = await res.json();
let allSessions = buildSessionsFromFrames(data.frames || []);
if (config.recurringMode) {
if (selectedLocationId) allSessions = allSessions.filter(session => String(session.locationId || '') === String(selectedLocationId));
availableDateChoices = buildAvailableDateChoices(allSessions);
sessions = dateInput?.value ? allSessions.filter(session => dateValueInZone(session.start) === dateInput.value) : allSessions;
} else {
availableDateChoices = [];
sessions = config.hasNights ? applyNightFilter(allSessions) : allSessions;
}
if (!sessions.length && !config.recurringMode && !config.hasNights) sessions = buildFallbackSessions();
sessions.sort((a, b) => new Date(a.start || 0) - new Date(b.start || 0));
};
const nightDateToken = iso => normalizeText(fmtDate(iso));
const variantNight = session => String((config.variantMap[String(session.externalId)] || {}).night || '');
const sessionBelongsToNight = session => {
const label = normalizeText(variantNight(session));
const token = nightDateToken(session.start);
if (!label || !token) return false;
return new RegExp('(^|\\s)' + token.replace(/\s+/g, '\\s+') + '(\\s|$)').test(label);
};
const nightKeyFor = session => `night-${dateValueInZone(session.start)}-${String(session.start).slice(11, 16)}`;
const applyNightFilter = all => {
const matched = all.filter(sessionBelongsToNight);
const byKey = new Map();
matched.forEach(session => {
const key = nightKeyFor(session);
const entry = byKey.get(key) || { key, start: session.start, finish: session.finish, locationId: session.locationId, label: variantNight(session), pieces: 0, open: 0 };
entry.pieces += 1;
entry.open += Number(session.available || 0);
if (!entry.locationId && session.locationId) entry.locationId = session.locationId;
byKey.set(key, entry);
});
eventNights = Array.from(byKey.values()).sort((a, b) => new Date(a.start) - new Date(b.start));
if (!eventNights.some(item => item.key === selectedNightKey)) selectedNightKey = (eventNights[0] || {}).key || '';
renderNightOptions();
if (typeof syncVenueLabel === 'function') syncVenueLabel();
return matched.filter(session => nightKeyFor(session) === selectedNightKey);
};
const renderNightOptions = () => {
if (!nightGroup || !nightOptions) return;
if (!eventNights.length) { nightGroup.hidden = true; nightOptions.innerHTML = ''; return; }
nightGroup.hidden = false;
const locName = id => {
const location = btaLocations().find(item => String(item.id) === String(id));
const raw = String(location?.name || '').trim();
return raw && !/^eaps\s/i.test(raw) ? raw : 'Bright Eye Beer Co';
};
nightOptions.innerHTML = eventNights.map(night => {
const time = night.start && night.finish ? `${fmtTime(night.start)}–${fmtTime(night.finish)}` : '';
const soldOut = night.open <= 0;
return `<button type="button" class="rb__studio-option" data-rb-night="${esc(night.key)}" aria-pressed="${night.key === selectedNightKey ? 'true' : 'false'}"><strong>${esc(night.label)}</strong><span>${esc([time, locName(night.locationId)].filter(Boolean).join(' · '))}${soldOut ? ' · Sold out' : ''}</span></button>`;
}).join('');
nightOptions.querySelectorAll('[data-rb-night]').forEach(button => button.addEventListener('click', async () => {
if (button.dataset.rbNight === selectedNightKey) return;
selectedNightKey = button.dataset.rbNight;
selectedIds.clear();
Object.keys(projectQuantities).forEach(key => delete projectQuantities[key]);
setStatus('Loading pieces...');
try {
await fetchFrames();
if (sessions[0]) setStageForSession(sessions[0]);
syncVenueLabel();
renderSessions();
updateSummary();
setStatus('');
} catch (err) {
sessions = [];
renderSessions();
updateSummary();
setStatus(err.message || 'Unable to load that night.', 'error');
}
}));
};
const availableSession = session => Number(session.status) === 1 && Number(session.available || 0) >= (config.leadOnly ? minQuantity() : 1);
const waitlistSession = session => Boolean(config.enableWaitlist && !config.isParty && session && session.start && !availableSession(session));
const selectableSession = session => availableSession(session) || waitlistSession(session);
const buildAvailableDateChoices = source => {
const byDate = new Map();
(source || []).forEach(session => {
if (!session?.start || !availableSession(session)) return;
const value = dateValueInZone(session.start);
const existing = byDate.get(value) || { value, first: session.start, count: 0 };
existing.count += 1;
if (new Date(session.start) < new Date(existing.first)) existing.first = session.start;
byDate.set(value, existing);
});
return Array.from(byDate.values()).sort((a, b) => new Date(a.first) - new Date(b.first));
};
const waitlistSelections = selected => selected.filter(waitlistSession);
const reservableSelections = selected => selected.filter(availableSession);
const selectionHasWaitlist = selected => waitlistSelections(selected).length > 0;
const selectionHasReservable = selected => reservableSelections(selected).length > 0;
const selectionIsWaitlist = selected => selected.length > 0 && selected.every(waitlistSession);
const selectionIsMixed = selected => selectionHasWaitlist(selected) && selectionHasReservable(selected);
const syncWaitlistChrome = selectedOrMode => {
const selected = Array.isArray(selectedOrMode) ? selectedOrMode : [];
const waitlistMode = Array.isArray(selectedOrMode) ? selectionHasWaitlist(selected) : Boolean(selectedOrMode);
const waitlistOnly = Array.isArray(selectedOrMode) ? selectionIsWaitlist(selected) : Boolean(selectedOrMode);
root.classList.toggle('rb--waitlist-mode', waitlistMode);
root.classList.toggle('rb--waitlist-only', waitlistOnly);
root.classList.toggle('rb--waitlist-mixed', Array.isArray(selectedOrMode) ? selectionIsMixed(selected) : false);
root.dataset.rbWaitlistMode = waitlistMode ? 'true' : 'false';
root.dataset.rbWaitlistOnly = waitlistOnly ? 'true' : 'false';
};
const sessionStatus = session => {
if (availableSession(session)) {
if (config.isParty) { return 'Available'; }
const seats = Number(session.available || 0);
if (config.freeHold) { return `${seats} table${seats === 1 ? '' : 's'} available`; }
if (config.leadOnly) {
const cap = Math.min(seats, Number(config.maxQuantity || 8));
if (cap < minQuantity()) return 'Sold out';
return cap >= Number(config.maxQuantity || 8) ? `Up to ${cap} people` : `${cap} wheels left`;
}
return `${seats} available`;
}
if (config.isParty) { return 'Booked'; }
return waitlistSession(session) ? 'Waitlist only' : 'Sold out';
};
const freeHoldSlotStatus = session => {
const seats = Number(session?.available || 0);
return `${seats} table${seats === 1 ? '' : 's'}`;
};
const sessionLabel = (session, idx) => config.isCamp ? `Week ${sessionNumber(session.name) || idx + 1}` : (config.recurringMode ? fmtDate(session.start) : `Session ${idx + 1}`);
const sessionMetaText = session => {
if (config.isEventProduct) {
const variant = config.variantMap[String(session.externalId)];
return variant?.money || '';
}
const time = session.start && session.finish ? `${fmtTime(session.start)}-${fmtTime(session.finish)}` : 'Time TBA';
return `${fmtRange(session)} · ${time}`;
};
const projectName = session => {
if (config.isEventProduct) {
const variant = config.variantMap[String(session.externalId)];
return variant?.piece || variant?.title || cleanName(session.name);
}
return cleanName(session.name).split(' - ')[0].trim() || cleanName(session.name);
};
const normalizeText = value => String(value || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
const projectTokens = session => normalizeText(projectName(session)).split(' ').filter(token => token.length > 2 && !['the','and','personal','project'].includes(token));
const mediaForSession = session => {
if (config.isEventProduct) {
const variant = config.variantMap[String(session.externalId)];
if (variant?.thumb) {
const strip = value => String(value || '').split('?')[0];
const idx = (config.media || []).findIndex(item => strip(item.src) === strip(variant.image));
return { src: variant.image, thumb: variant.thumb, alt: variant.piece || variant.title, index: idx >= 0 ? idx : 0 };
}
}
const media = config.media || [];
if (!media.length) return null;
const tokens = projectTokens(session);
let best = media[0];
let bestScore = 0;
media.forEach(item => {
const haystack = normalizeText(`${item.alt || ''} ${item.src || ''}`);
const score = tokens.reduce((sum, token) => sum + (haystack.includes(token) ? 1 : 0), 0);
if (score > bestScore) { bestScore = score; best = item; }
});
return best;
};
const mediaIndexForSession = session => {
const image = mediaForSession(session);
if (!image) return -1;
const explicit = Number(image.index);
if (Number.isFinite(explicit)) return explicit;
return (config.media || []).findIndex(item => item.src === image.src);
};
const sessionForMediaIndex = index => sessions.find(session => mediaIndexForSession(session) === Number(index)) || null;
const syncMobileMediaCaption = session => {
const match = session || sessionForMediaIndex(activeMediaIndex);
if (!mobileMediaCaption || !mobileMediaTitle || !mobileMediaMeta) return;
if (!match) {
mobileMediaCaption.hidden = true;
return;
}
mobileMediaTitle.textContent = projectName(match);
mobileMediaMeta.textContent = fmtRange(match);
mobileMediaCaption.hidden = false;
};
const projectDescriptions = {
'wall pocket': 'Build a small wall pocket from slab clay, shape the front, add texture, and finish it for firing.',
'personal chip and dip': 'Shape a personal serving piece with a dip well, soft edges, and surface details.',
'berry bowl': 'Make a small berry bowl with pierced drainage holes, a foot ring, and a finished rim.',
'mugs': 'Build a handbuilt mug form, attach a handle, and refine the shape for firing.',
'picture frames': 'Build a clay picture frame, add texture or carving, and finish it for firing.'
};
const projectDescription = session => {
if (config.isEventProduct) return `Choose your ceramic before arrival. Paint at ${eventVenueName()} with EAPS tools and guidance.`;
if (config.isCamp) return themeNotes[themeKey(session.name)] || 'A themed camp week with pottery, guided art projects, sensory activities, and studio games.';
return projectDescriptions[normalizeText(projectName(session))] || 'Shape, refine, and finish a handbuilt clay piece for firing.';
};
const instructorForSession = session => {
const handle = String(config.productHandle || '');
const map = config.instructors || {};
const hay = String((session && (session.name || session.title)) || '').toLowerCase();
const keys = Object.keys(map);
const hit = hay ? keys.find(key => key && hay.includes(String(key).toLowerCase())) : null;
if (hit && map[hit] && map[hit].name) return { name: map[hit].name, url: map[hit].url || '/pages/our-story#team' };
if (handle.includes('pottery-foundations')) return { name: 'Francesca Antonello', url: '/pages/our-story#team' };
if (handle.includes('young-potters')) return { name: 'Diana Roldan', url: '/pages/our-story#team' };
if (handle.includes('handbuilding') || handle.includes('hand-build') || handle.includes('hand_build')) return { name: 'Diana Roldan', url: '/pages/our-story#team' };
return null;
};
const instructorHtml = session => {
const instructor = instructorForSession(session);
if (!instructor || !instructor.name) return '';
const url = instructor.url || '/pages/our-story#team';
return `<p class="rb__project-instructor">Instructor: <a href="${esc(url)}" target="_blank" rel="noopener">${esc(instructor.name)}</a></p>`;
};
const sessionInstructorHtml = session => {
const instructor = instructorForSession(session);
if (!instructor || !instructor.name) return '';
const url = instructor.url || '/pages/our-story#team';
return `<a class="rb__session-instructor" href="${esc(url)}" target="_blank" rel="noopener" data-rb-instructor-link>Instructor: ${esc(instructor.name)}</a>`;
};
const setActiveMedia = index => {
const media = config.media || [];
if (!media.length || !mainImage) return;
const count = media.length;
activeMediaIndex = ((Number(index) || 0) % count + count) % count;
const item = media[activeMediaIndex];
if (item?.src) {
mainImage.src = item.src;
mainImage.alt = item.alt || config.productTitle;
}
carouselDots.forEach(dot => dot.setAttribute('aria-current', Number(dot.dataset.index) === activeMediaIndex ? 'true' : 'false'));
syncMobileMediaCaption();
};
const setMediaForSession = session => {
const idx = mediaIndexForSession(session);
if (idx < 0) return;
setActiveMedia(idx);
if (mainImage) mainImage.alt = projectName(session);
};
const setStageForSession = session => {
setMediaForSession(session);
syncMobileMediaCaption(session);
if (stageTitle) stageTitle.textContent = projectName(session);
if (stageNote) stageNote.textContent = sessionMetaText(session);
};
const projectMax = session => {
if (!session) return 0;
if (waitlistSession(session)) return 1;
return Math.max(0, Math.min(Number(config.maxQuantity || 8), Number(session.available || 0)));
};
const readProjectPeopleFromDom = () => {
const data = {};
peopleEl.querySelectorAll('[data-rb-project-person]').forEach(card => {
const key = card.dataset.sessionKey;
const index = Number(card.dataset.index || 0);
data[key] = data[key] || [];
const person = {};
card.querySelectorAll('[data-rb-field]').forEach(input => { person[input.dataset.rbField] = input.value || ''; });
data[key][index] = person;
});
return data;
};
const waitlistContactHtml = (session, saved = {}) => `
<div class="rb__waitlist-card" data-rb-project-person data-rb-waitlist-contact data-session-key="${esc(session.key)}" data-index="0">
<span class="rb__waitlist-badge">Waitlist only</span>
<h3>Your details</h3>
<p>This session is waitlist only. Leave your contact information and EAPS will reach out if a spot opens.</p>
<div class="rb__fields">
<div class="rb__field rb__field--wide"><label>Name</label><input required data-rb-field="guest_name" autocomplete="name" value="${esc(saved.guest_name || '')}"></div>
<div class="rb__field rb__field--wide"><label>Email</label><input required data-rb-field="guest_email" type="email" inputmode="email" autocomplete="email" placeholder="name@email.com" value="${esc(saved.guest_email || '')}"></div>
<div class="rb__field rb__field--wide"><label>Phone</label><input required data-rb-field="guest_phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="+1 (516) 555-1234" value="${esc(saved.guest_phone || '')}"></div>
</div>
</div>`;
const renderProjectPeople = () => {
const selected = selectedSessions();
if (!selected.length) {
peopleEl.innerHTML = '';
return;
}
const existing = readProjectPeopleFromDom();
const groups = selected.map((session, sessionIndex) => {
if (waitlistSession(session)) {
return waitlistContactHtml(session, (existing[session.key] || [])[0] || {});
}
const qty = projectQuantity(session);
const people = Array.from({ length: qty }, (_, i) => {
const saved = existing[session.key]?.[i] || {};
const priorSource = selected.slice(0, sessionIndex).reverse().find(item => !waitlistSession(item) && projectQuantity(item) > i);
const personNoun = quantityNoun();
const personLabel = quantityLabel();
const copyNoun = personNoun.charAt(0).toUpperCase() + personNoun.slice(1);
const copyTargetLabel = `${copyNoun} ${i + 1}`;
const copyLabel = `Same as ${copyTargetLabel} above`;
const copyButton = priorSource ? `<button type="button" class="rb__same-student" data-rb-copy-source data-source-session="${esc(priorSource.key)}" data-source-index="${i}" data-copy-target-label="${esc(copyTargetLabel)}" aria-pressed="false">${esc(copyLabel)}</button>` : '';
const fields = kidMode() ? `
<div class="rb__field"><label>${kidLabel()} name</label><input required data-rb-field="camper_name" autocomplete="off" value="${esc(saved.camper_name || '')}"></div>
<div class="rb__field"><label>Age</label><select required data-rb-field="camper_age"><option value="">Age</option>${kidAgeList().map(age => `<option${String(saved.camper_age || '') === String(age) ? ' selected' : ''}>${age}</option>`).join('')}</select></div>
<div class="rb__field rb__field--wide"><label>Parent/guardian name</label><input required data-rb-field="emergency_contact_name" autocomplete="name" value="${esc(saved.emergency_contact_name || '')}"></div>
<div class="rb__field rb__field--wide"><label>Parent/guardian phone</label><input required data-rb-field="emergency_contact_phone_number" type="tel" inputmode="tel" autocomplete="tel" placeholder="+1 (516) 555-1234" value="${esc(saved.emergency_contact_phone_number || '')}"></div>
<div class="rb__field rb__field--wide"><label>Allergies or medical considerations</label><textarea data-rb-field="allergies_or_medical_considerations">${esc(saved.allergies_or_medical_considerations || '')}</textarea></div>` : `
<div class="rb__field rb__field--wide"><label>${personLabel === 'Person' ? 'Name' : esc(personLabel) + ' name'}</label><input required data-rb-field="guest_name" autocomplete="name" value="${esc(saved.guest_name || '')}"></div>
<div class="rb__field rb__field--wide"><label>Email</label><input required type="email" data-rb-field="guest_email" autocomplete="email" placeholder="name@email.com" value="${esc(saved.guest_email || '')}"></div>
<div class="rb__field rb__field--wide"><label>Phone</label><input required data-rb-field="guest_phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="+1 (516) 555-1234" value="${esc(saved.guest_phone || '')}"></div>`;
return `
<div class="rb__person" data-rb-project-person data-session-key="${esc(session.key)}" data-index="${i}">
<h3>${qty === 1 ? (personLabel === 'Person' ? "Who's coming" : personLabel) : personLabel + ' ' + (i + 1)}</h3>
${copyButton}
<div class="rb__fields">${fields}</div>
</div>`;
}).join('');
return `
<div class="rb__person-group" data-rb-project-group data-session-key="${esc(session.key)}">
<h3>${esc(projectName(session))}</h3>
<p>${esc(sessionMetaText(session))}</p>
${people}
</div>`;
}).join('');
peopleEl.innerHTML = groups;
if (config.miniSeries && miniSeriesMirror) {
const groupsNow = () => [...peopleEl.querySelectorAll('[data-rb-project-group]')];
const mirrorFrom = (field, sourceCard) => {
groupsNow().slice(1).forEach(group => {
const card = group.querySelector(`[data-rb-project-person][data-index="${sourceCard.dataset.index}"]`);
const target = card?.querySelector(`[data-rb-field="${field}"]`);
if (!target || target.dataset.rbMirror === 'off') return;
target.value = sourceCard.querySelector(`[data-rb-field="${field}"]`)?.value || '';
target.dataset.rbMirror = 'on';
});
};
if (!peopleEl.dataset.rbMirrorBound) {
peopleEl.dataset.rbMirrorBound = 'true';
peopleEl.addEventListener('input', event => {
if (!miniSeriesMirror) return;
const field = event.target?.dataset?.rbField; if (!field) return;
const card = event.target.closest('[data-rb-project-person]'); if (!card) return;
const group = card.closest('[data-rb-project-group]');
if (group === groupsNow()[0]) mirrorFrom(field, card);
else if (event.isTrusted) event.target.dataset.rbMirror = 'off';
});
}
groupsNow().slice(1).forEach(group => { group.hidden = true; group.style.display = 'none'; group.setAttribute('aria-hidden', 'true'); group.querySelectorAll('[data-rb-copy-source]').forEach(button => { button.hidden = true; }); });
const firstGroup = groupsNow()[0];
if (firstGroup) {
const gh = firstGroup.querySelector('h3'); if (gh) gh.textContent = 'Mini series · all ' + groupsNow().length + ' Sundays';
const gp = firstGroup.querySelector('p'); if (gp) gp.textContent = 'One maker takes every date. Enter your details once - they cover all ' + groupsNow().length + ' Sundays.';
firstGroup.querySelectorAll('[data-rb-project-person] h3').forEach(h => { h.textContent = "Who's coming"; });
}
const firstCard = groupsNow()[0]?.querySelector('[data-rb-project-person]');
if (firstCard) firstCard.querySelectorAll('[data-rb-field]').forEach(input => { if (input.value) mirrorFrom(input.dataset.rbField, firstCard); });
}
peopleEl.querySelectorAll('[data-rb-copy-source]').forEach(button => button.addEventListener('click', () => {
const current = button.closest('[data-rb-project-person]');
const source = [...peopleEl.querySelectorAll('[data-rb-project-person]')].find(card => card.dataset.sessionKey === button.dataset.sourceSession && card.dataset.index === button.dataset.sourceIndex);
if (!source || !current) return;
const copyFields = kidMode() ? ['camper_name', 'camper_age', 'emergency_contact_name', 'emergency_contact_phone_number', 'allergies_or_medical_considerations'] : ['guest_name', 'guest_email', 'guest_phone'];
copyFields.forEach(field => {
const sourceInput = source.querySelector(`[data-rb-field="${field}"]`);
const target = current.querySelector(`[data-rb-field="${field}"]`);
if (sourceInput && target) {
target.value = sourceInput.value;
target.dispatchEvent(new Event('input', { bubbles: true }));
target.dispatchEvent(new Event('change', { bubbles: true }));
}
});
const copiedLabel = button.dataset.copyTargetLabel || (kidMode() ? kidLabel() : quantityLabel());
button.textContent = copiedLabel;
button.setAttribute('aria-pressed', 'true');
button.classList.add('is-copied');
setStatus('');
}));
bindPhoneInputs();
bindEmailInputs();
};
const renderProjectList = () => {
if (!projectList) return;
if (!sessions.length) {
projectList.innerHTML = `<p class="rb__fine">${config.isEventProduct ? 'The next night hasn’t been announced yet — check back soon.' : 'No online project dates are available yet.'}</p>`;
return;
}
const miniEligible = config.miniSeries ? sessions.filter(item => selectableSession(item) && !waitlistSession(item)) : [];
const miniAll = miniEligible.length > 1 && miniEligible.every(item => projectQuantity(item) > 0);
const miniBar = miniEligible.length > 1 ? `
<div class="rb__mini-series" data-rb-mini-series data-active="${miniAll ? 'true' : 'false'}">
<p class="rb__mini-series-kicker">Make it a mini series</p>
<p class="rb__mini-series-body">Want to take all ${miniEligible.length} Sundays? Select every date in one click and it becomes a mini series: <strong>10% off the total</strong>, plus <strong>open studio hours between sessions</strong> to keep working on your pieces. For one maker - you'll enter your details once.</p>
<button type="button" class="rb__mini-series-button" data-rb-mini-series-button aria-pressed="${miniAll ? 'true' : 'false'}">${miniAll ? `Mini series selected · 10% off at checkout` : `Select all ${miniEligible.length} Sundays · 10% off`}</button>
${miniAll ? `<p class="rb__fine">Changed your mind? Click again to pick individual Sundays.</p>` : ``}
</div>` : '';
projectList.innerHTML = miniBar + sessions.map(session => {
if (!(session.key in projectQuantities)) projectQuantities[session.key] = 0;
const selectable = selectableSession(session);
const qty = projectQuantity(session);
const image = mediaForSession(session);
const max = projectMax(session);
const statusText = waitlistSession(session) ? 'Waitlist only' : sessionStatus(session);
const displayName = config.isCamp ? (sessionLabel(session, sessions.indexOf(session)) + (cleanName(session.name) ? ` · ${cleanName(session.name)}` : '')) : projectName(session);
return `
<div class="rb__project-card" data-rb-project-card data-key="${esc(session.key)}" data-selected="${qty > 0 ? 'true' : 'false'}" data-disabled="${selectable ? 'false' : 'true'}" data-waitlist="${waitlistSession(session) ? 'true' : 'false'}" role="listitem">
<button type="button" class="rb__project-button" data-rb-project-button data-key="${esc(session.key)}" ${selectable ? '' : 'disabled'} aria-label="${esc(displayName)} - ${esc(sessionMetaText(session))}">
<span class="rb__project-visual">${image?.thumb ? `<img src="${esc(image.thumb)}" alt="" loading="lazy" width="180" height="180">` : ''}</span>
<span class="rb__project-copy">
<strong>${esc(displayName)}</strong>
<span>${esc(sessionMetaText(session))}</span>
<span class="rb__project-status" data-waitlist="${waitlistSession(session) ? 'true' : 'false'}">${esc(statusText)}</span>
</span>
</button>
<div class="rb__project-qty" aria-label="Quantity for ${esc(projectName(session))}">
<button type="button" data-rb-project-minus data-key="${esc(session.key)}" aria-label="Remove ${esc(projectName(session))}" ${qty <= 0 ? 'disabled' : ''}>−</button>
<output data-rb-project-qty>${qty}</output>
<button type="button" data-rb-project-plus data-key="${esc(session.key)}" aria-label="Add ${esc(projectName(session))}" ${!selectable || qty >= max ? 'disabled' : ''}>+</button>
</div>
<p class="rb__project-detail rb__project-description">${esc(projectDescription(session))}</p>
${instructorHtml(session)}
</div>`;
}).join('');
projectList.querySelectorAll('[data-rb-mini-series-button]').forEach(button => button.addEventListener('click', event => {
event.stopPropagation();
const eligible = sessions.filter(item => selectableSession(item) && !waitlistSession(item));
const allOn = eligible.length && eligible.every(item => projectQuantity(item) > 0);
eligible.forEach(item => { projectQuantities[item.key] = allOn ? 0 : Math.max(1, projectQuantity(item)); });
miniSeriesMirror = !allOn;
if (!allOn && eligible[0]) setStageForSession(eligible[0]);
renderProjectList();
updateSummary();
setStatus('');
}));
projectList.querySelectorAll('[data-rb-project-plus]').forEach(button => button.addEventListener('click', event => { event.stopPropagation(); changeProjectQuantity(button.dataset.key, 1); }));
projectList.querySelectorAll('[data-rb-project-minus]').forEach(button => button.addEventListener('click', event => { event.stopPropagation(); changeProjectQuantity(button.dataset.key, -1); }));
projectList.querySelectorAll('[data-rb-project-button]').forEach(button => {
button.addEventListener('click', () => {
if (button.disabled) return;
const session = sessions.find(item => item.key === button.dataset.key);
if (!session) return;
if (projectQuantity(session) === 0) changeProjectQuantity(session.key, 1);
else setStageForSession(session);
});
button.addEventListener('mouseenter', () => {
const session = sessions.find(item => item.key === button.dataset.key);
if (session) setStageForSession(session);
});
button.addEventListener('focus', () => {
const session = sessions.find(item => item.key === button.dataset.key);
if (session) setStageForSession(session);
});
});
};
const changeProjectQuantity = (key, delta) => {
const session = sessions.find(item => item.key === key);
if (!session || !selectableSession(session)) return;
if (config.miniSeries && miniSeriesMirror) miniSeriesMirror = false;
const current = projectQuantity(session);
const next = Math.max(0, Math.min(current + delta, projectMax(session)));
if (next === current) return;
projectQuantities[key] = next;
if (next > 0) setStageForSession(session);
renderProjectList();
updateSummary();
setStatus('');
};
const syncSessionPresentation = () => {
const inline = inlineSessionMode();
root.dataset.rbInlineSessions = inline ? 'true' : 'false';
root.dataset.rbFhTimeMode = (config.freeHold && !!dateInput?.value) ? 'true' : 'false';
if (!sessionModal) return;
if (inline) {
sessionModal.hidden = false;
if (openSessions) openSessions.setAttribute('aria-expanded', 'true');
} else if (!sessionModal.contains(document.activeElement)) {
sessionModal.hidden = true;
if (openSessions) openSessions.setAttribute('aria-expanded', 'false');
}
window.requestAnimationFrame(positionDateControl);
};
const syncDateSelectOptions = () => {
if (!dateSelect) return;
const choices = availableDateChoices || [];
const current = dateInput?.value || '';
const placeholder = choices.length ? '<option value="">Pick an available date</option>' : '<option value="">No dates available</option>';
dateSelect.innerHTML = placeholder + choices.map(day => `<option value="${esc(day.value)}">${esc(fmtDateValue(day.value))}${day.count > 1 ? ` · ${day.count} times` : ''}</option>`).join('');
dateSelect.disabled = !choices.length;
if (current && choices.some(day => day.value === current)) dateSelect.value = current;
else dateSelect.value = '';
};
const positionDateControl = () => {
syncDateSelectOptions();
if (!calendarControl || !calendarField || !sessionList) return;
const card = sessionList.querySelector('[data-rb-calendar-card]');
if (!card) {
calendarControl.hidden = true;
return;
}
const fieldRect = calendarField.getBoundingClientRect();
const cardRect = card.getBoundingClientRect();
calendarControl.hidden = false;
calendarControl.style.left = `${cardRect.left - fieldRect.left}px`;
calendarControl.style.top = `${cardRect.top - fieldRect.top}px`;
calendarControl.style.width = `${cardRect.width}px`;
calendarControl.style.height = `${cardRect.height}px`;
};
const openDatePicker = event => {
if (!dateSelect) return;
const directSelectClick = event && event.target === dateSelect;
dateSelect.focus({ preventScroll: false });
if (typeof dateSelect.showPicker === 'function') {
try { dateSelect.showPicker(); return; } catch (_) {}
}
if (!directSelectClick) {
try { dateSelect.click(); } catch (_) {}
}
};
const calendarCardHtml = (mode = 'default') => {
if (!config.recurringMode || !dateInput) return '';
const picked = !!dateInput.value;
if (config.freeHold && picked && mode === 'selected') {
return `<div class="rb__selected-date" data-rb-selected-date data-rb-calendar-card><span>Selected date</span><strong>${esc(fmtDateValue(dateInput.value))}</strong><span class="rb__calendar-action">Change date</span></div>`;
}
const title = picked ? 'Change date' : 'Looking further out?';
const detail = picked ? fmtDateValue(dateInput.value) : 'Pick a date';
return `<div class="rb__session-calendar" data-rb-calendar-card role="button" aria-pressed="${picked ? 'true' : 'false'}" aria-label="${esc(title)}"><strong>${esc(title)}</strong><span>${esc(detail)}</span></div>`;
};
const freeHoldDateOptions = () => {
const byDate = new Map();
sessions.forEach(session => {
if (!session.start || !availableSession(session)) return;
const value = dateValueInZone(session.start);
const current = byDate.get(value) || { value, count: 0, tables: 0, first: session.start };
current.count += 1;
current.tables += Number(session.available || 0);
if (new Date(session.start) < new Date(current.first)) current.first = session.start;
byDate.set(value, current);
});
return Array.from(byDate.values()).sort((a, b) => new Date(a.first) - new Date(b.first));
};
const selectFreeHoldDate = async value => {
if (!dateInput || !value) return;
dateInput.value = value;
selectedIds.clear();
calendarPicked = true;
setStatus('Loading times for that date...');
try {
await fetchFrames();
renderSessions();
updateSummary();
setStatus('');
} catch (err) {
sessions = [];
renderSessions();
updateSummary();
setStatus(err.message || 'Unable to load times for that date.', 'error');
}
};
const renderFreeHoldDates = () => {
if (root) root.dataset.rbFhTimeMode = 'false';
const dates = freeHoldDateOptions();
const visibleDates = dates.slice(0, 4);
const cards = visibleDates.map(day => `
<button type="button" class="rb__session" data-rb-fh-date="${esc(day.value)}" data-selected="false">
<span class="rb__session-top"><span>${esc(fmtDateValue(day.value))}</span><span class="rb__session-status">${esc(day.count)} time${day.count === 1 ? '' : 's'}</span></span>
<strong>${esc(new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: config.timeZone }).format(new Date(day.first)))}</strong>
<em>${esc(day.tables)} table${day.tables === 1 ? '' : 's'} available across the day</em>
</button>`).join('');
sessionList.innerHTML = (cards || '<p class="rb__fine">No reservation dates are open for this group size yet.</p>') + calendarCardHtml();
sessionList.querySelectorAll('[data-rb-fh-date]').forEach(button => button.addEventListener('click', () => selectFreeHoldDate(button.dataset.rbFhDate)));
positionDateControl();
if (sessionTitle) sessionTitle.textContent = 'Choose a date';
if (sessionMeta) sessionMeta.textContent = dates.length ? 'Times appear after you choose a date.' : 'Try another group size or pick a later date.';
if (sessionCount) sessionCount.textContent = String(dates.length);
if (sessionFoot) sessionFoot.textContent = dates.length ? `${dates.length} date${dates.length === 1 ? '' : 's'} with open tables.` : 'No open dates found.';
if (availabilityNote) availabilityNote.textContent = dates.length ? 'Live availability' : 'No dates';
syncSessionPresentation();
};
const renderSessions = () => {
if (config.projectQuantityMode) {
renderProjectList();
return;
}
if (config.freeHold && !dateInput?.value) {
renderFreeHoldDates();
return;
}
if (config.recurringMode && !selectedLocationId && btaLocations().length > 1) {
sessionList.innerHTML = '<p class="rb__fine">Pick a studio above — upcoming dates for that studio will appear here.</p>';
positionDateControl();
if (sessionFoot) sessionFoot.textContent = 'Dates appear once you pick a studio.';
syncSessionPresentation();
return;
}
if (!sessions.length) {
if (config.freeHold && root) root.dataset.rbFhTimeMode = dateInput?.value ? 'true' : 'false';
sessionList.innerHTML = config.recurringMode ? `${calendarCardHtml()}<p class="rb__fine">No online sessions are open for this studio/date yet.</p>` : '<p class="rb__fine">No online sessions are available yet.</p>';
positionDateControl();
sessionFoot.textContent = config.freeHold ? 'Pick another date.' : (config.recurringMode ? 'Pick another date or studio.' : 'No online availability.');
syncSessionPresentation();
return;
}
/* Anchored default list: start one closed date before the first opening, then run chronologically — the near-miss carries the FOMO and every card stays temporally relevant; the scarcity line above the list carries the mass of everything booked earlier */
const pickDefaultSessions = () => {
const firstOpenIdx = sessions.findIndex(availableSession);
if (firstOpenIdx === -1) return sessions.slice(0, 4);
const start = Math.max(0, firstOpenIdx - 1);
return sessions.slice(start, start + 4);
};
const visibleSessions = config.recurringMode && !dateInput?.value ? pickDefaultSessions() : sessions;
if (config.freeHold && root) root.dataset.rbFhTimeMode = dateInput?.value ? 'true' : 'false';
const selectedDateCard = config.freeHold && dateInput?.value ? calendarCardHtml('selected') : '';
const trailingCalendarCard = config.freeHold && dateInput?.value ? '' : calendarCardHtml();
const scarcityHtml = (() => {
if (!(config.recurringMode && !dateInput?.value)) return '';
const firstOpenIdx = sessions.findIndex(availableSession);
if (firstOpenIdx < 2) return '';
const closedWord = config.isParty ? 'Booked' : 'Sold out';
return `<p class="rb__scarcity">${esc(closedWord)} through ${esc(fmtDate(sessions[firstOpenIdx - 1].start))} &mdash; next opening is ${esc(fmtDate(sessions[firstOpenIdx].start))}.</p>`;
})();
sessionList.innerHTML = scarcityHtml + selectedDateCard + visibleSessions.map((session, idx) => {
const selectable = selectableSession(session);
const selected = selectedIds.has(session.key);
const qtyMax = Math.min(Number(config.maxQuantity || 8), waitlistSession(session) ? Number(config.maxQuantity || 8) : Math.max(1, Number(session.available || 1)));
return `
<button type="button" class="rb__session${config.freeHold ? ' rb__session--fh-time' : ''}" data-rb-session data-key="${esc(session.key)}" data-waitlist="${waitlistSession(session) ? 'true' : 'false'}" data-selected="${selected ? 'true' : 'false'}" ${selectable ? '' : 'disabled'}>
${config.freeHold ? `
<span class="rb__session-fh"><strong>${esc(fmtTime(session.start))}</strong><span class="rb__session-status">${esc(config.freeHold ? freeHoldSlotStatus(session) : sessionStatus(session))}</span></span>
` : `
<span class="rb__session-top"><span>${esc(config.recurringMode ? fmtDate(session.start) : sessionLabel(session, idx))}</span><span class="rb__session-status">${esc(config.freeHold ? freeHoldSlotStatus(session) : sessionStatus(session))}</span></span>
<strong>${esc(config.recurringMode ? fmtTime(session.start) : cleanName(session.name))}</strong>
<em>${esc(config.recurringMode ? `${fmtDayLong(session.start)} · ${fmtTime(session.start)}-${fmtTime(session.finish)}` : sessionMetaText(session))}</em>
${sessionInstructorHtml(session)}
${config.isParty ? '' : `<span class="rb__session-location">${esc(sessionLocationName(session))}</span>`}
<span class="rb__session-qty" aria-label="Quantity for selected session">
<span>${esc(pluralize(quantity, quantityNoun()).replace(/^\d+\s+/, ''))}</span>
<span class="rb__session-qty-control">
<span role="button" tabindex="0" data-rb-inline-minus aria-label="Decrease" aria-disabled="${quantity <= minQuantity() ? 'true' : 'false'}">−</span>
<output>${quantity}</output>
<span role="button" tabindex="0" data-rb-inline-plus aria-label="Increase" aria-disabled="${quantity >= qtyMax ? 'true' : 'false'}">+</span>
</span>
</span>
`}
</button>`;
}).join('') + trailingCalendarCard;
sessionList.querySelectorAll('[data-rb-session]').forEach(button => button.addEventListener('click', () => toggleSession(button.dataset.key)));
sessionList.querySelectorAll('[data-rb-instructor-link]').forEach(link => link.addEventListener('click', event => { event.stopPropagation(); }));
sessionList.querySelectorAll('[data-rb-inline-minus]').forEach(control => control.addEventListener('click', event => { event.stopPropagation(); if (control.getAttribute('aria-disabled') === 'true') return; quantity -= 1; updateSummary(); renderSessions(); }));
sessionList.querySelectorAll('[data-rb-inline-plus]').forEach(control => control.addEventListener('click', event => { event.stopPropagation(); if (control.getAttribute('aria-disabled') === 'true') return; quantity += 1; updateSummary(); renderSessions(); }));
positionDateControl();
const availableCount = sessions.filter(availableSession).length;
const waitlistCount = sessions.filter(waitlistSession).length;
sessionFoot.textContent = config.freeHold ? `${availableCount} available time${availableCount === 1 ? '' : 's'} for ${fmtDateValue(dateInput?.value)}.` : `${availableCount} available ${config.isCamp ? (availableCount === 1 ? 'week' : 'weeks') : (availableCount === 1 ? 'session' : 'sessions')}${waitlistCount ? ` · ${waitlistCount} waitlist` : ''}.`;
syncSessionPresentation();
};
let lockedScrollY = 0;
const lockPageForModal = () => {
lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
document.documentElement.style.overflow = 'hidden';
document.documentElement.style.overscrollBehavior = 'none';
document.body.style.position = 'fixed';
document.body.style.top = `-${lockedScrollY}px`;
document.body.style.left = '0';
document.body.style.right = '0';
document.body.style.width = '100%';
document.body.style.overflow = 'hidden';
document.body.style.touchAction = 'none';
};
const unlockPageForModal = () => {
document.documentElement.style.overflow = '';
document.documentElement.style.overscrollBehavior = '';
document.body.style.position = '';
document.body.style.top = '';
document.body.style.left = '';
document.body.style.right = '';
document.body.style.width = '';
document.body.style.overflow = '';
document.body.style.touchAction = '';
window.scrollTo(0, lockedScrollY || 0);
};
const openModal = modal => {
modal.hidden = false;
if (modal === sessionModal && openSessions) openSessions.setAttribute('aria-expanded', 'true');
if (modal !== sessionModal) lockPageForModal();
};
const closeModal = modal => {
modal.hidden = true;
if (modal === sessionModal && openSessions) openSessions.setAttribute('aria-expanded', 'false');
if (modal !== sessionModal && waiverModal.hidden) unlockPageForModal();
};
const toggleSession = key => {
const session = sessions.find(item => item.key === key);
if (!session || !selectableSession(session)) return;
if (selectedIds.has(key)) selectedIds.delete(key);
else {
if (!config.allowMultiple) selectedIds.clear();
selectedIds.add(key);
}
renderSessions();
updateSummary();
if (!config.allowMultiple && !inlineSessionMode()) closeModal(sessionModal);
};
const maxAvailable = () => {
const selected = selectedSessions();
if (!selected.length) return config.leadOnly ? Number(config.maxQuantity || 8) : 1;
if (selected.some(waitlistSession)) return Number(config.maxQuantity || 8);
return Math.max(1, Math.min(...selected.map(session => Number(session.available || 1))));
};
const clampQuantity = () => {
if (config.projectQuantityMode) {
if (qtyOut) qtyOut.textContent = String(Math.max(1, totalProjectQuantity()));
return;
}
const max = Math.min(Number(config.maxQuantity || 8), maxAvailable());
const selected = selectedSessions();
const waitlisting = selected.some(waitlistSession);
quantity = Math.max(Math.min(minQuantity(), max), Math.min(quantity, max));
if (minus) minus.disabled = quantity <= minQuantity();
if (plus) plus.disabled = quantity >= max;
if (qtyOut) qtyOut.textContent = String(quantity);
if (qtyCap) {
qtyCap.textContent = '';
qtyCap.hidden = true;
}
if (qtyNote) qtyNote.textContent = selectedIds.size ? (waitlisting ? 'Waitlist' : `${max} max`) : '';
};
const personFieldKey = el => {
const card = el.closest('[data-rb-person], [data-rb-project-person]');
const idx = card ? (card.getAttribute('data-rb-person') || card.getAttribute('data-index') || '0') : '0';
return idx + ':' + (el.dataset.rbField || '');
};
const snapshotPeopleFields = () => {
const snap = { values: {}, focusKey: null, caret: null };
peopleEl.querySelectorAll('[data-rb-field]').forEach(el => {
const key = personFieldKey(el);
snap.values[key] = el.value;
if (el === document.activeElement) {
snap.focusKey = key;
try { snap.caret = [el.selectionStart, el.selectionEnd]; } catch (err) { snap.caret = null; }
}
});
return snap;
};
const restorePeopleFields = snap => {
if (!snap) return;
peopleEl.querySelectorAll('[data-rb-field]').forEach(el => {
const key = personFieldKey(el);
if (key in snap.values && !el.value && snap.values[key]) el.value = snap.values[key];
if (snap.focusKey === key && document.activeElement !== el) {
try { el.focus({ preventScroll: true }); if (snap.caret) el.setSelectionRange(snap.caret[0], snap.caret[1]); } catch (err) {}
}
});
};
const renderPeople = () => {
if (config.isEventProduct) return;
if (config.projectQuantityMode) {
renderProjectPeople();
return;
}
const fieldSnap = snapshotPeopleFields();
const selected = selectedSessions();
if (selectionIsWaitlist(selected)) {
const current = collectWaitlistContact();
peopleEl.innerHTML = `
<div class="rb__waitlist-card" data-rb-person="0" data-rb-waitlist-contact>
<span class="rb__waitlist-badge">Waitlist only</span>
<h3>Your details</h3>
<p>This session is waitlist only. Leave your contact information and EAPS will reach out if a spot opens.</p>
<div class="rb__fields">
<div class="rb__field rb__field--wide"><label>Name</label><input required data-rb-field="guest_name" autocomplete="name" value="${esc(current.guest_name || '')}"></div>
<div class="rb__field rb__field--wide"><label>Email</label><input required data-rb-field="guest_email" type="email" inputmode="email" autocomplete="email" placeholder="name@email.com" value="${esc(current.guest_email || '')}"></div>
<div class="rb__field rb__field--wide"><label>Phone</label><input required data-rb-field="guest_phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="+1 (516) 555-1234" value="${esc(current.guest_phone || '')}"></div>
</div>
</div>`;
restorePeopleFields(fieldSnap);
bindPhoneInputs();
bindEmailInputs();
return;
}
const cards = [];
for (let i = 0; i < peopleCount(); i++) {
if (config.leadOnly) {
const guestRows = Array.from({ length: quantity }, (_, g) => `
<div class="rb__field"><label>${g === 0 ? 'Guest 1 (you)' : 'Guest ' + (g + 1)}</label><input required data-rb-field="guest${g + 1}_name" data-index="${i}" autocomplete="off" placeholder="First name"></div>
<div class="rb__field"><label>Age</label><select required data-rb-field="guest${g + 1}_age" data-index="${i}"><option value="">Age</option>${guestAgeOptions().map(a => `<option${g === 0 && a === 'Adult' ? ' selected' : ''}>${a}</option>`).join('')}</select></div>`).join('');
cards.push(`
<div class="rb__person" data-rb-person="${i}">
<h3>Booking contact</h3>
<p class="rb__fine">One reservation covers your group of ${quantity}. Everyone signs the waiver at the studio.</p>
<div class="rb__fields">
<div class="rb__field rb__field--wide"><label>Name</label><input required data-rb-field="guest_name" data-index="${i}" autocomplete="name"></div>
<div class="rb__field rb__field--wide"><label>Email</label><input required type="email" data-rb-field="guest_email" data-index="${i}" autocomplete="email" placeholder="name@email.com"></div>
<div class="rb__field rb__field--wide"><label>Phone</label><input required data-rb-field="guest_phone" data-index="${i}" type="tel" inputmode="tel" autocomplete="tel" placeholder="+1 (516) 555-1234"></div>
</div>
<h3 class="rb__group-heading">Who's throwing</h3>
<p class="rb__fine">A name and age for each of the ${quantity} wheels, so we can set the studio up for your group.</p>
<div class="rb__fields">${guestRows}</div>
</div>`);
} else if (kidMode()) {
cards.push(`
<div class="rb__person" data-rb-person="${i}">
<h3>${quantity === 1 ? kidLabel() : kidLabel() + ' ' + (i + 1)}</h3>
<div class="rb__fields">
<div class="rb__field"><label>${kidLabel()} name</label><input required data-rb-field="camper_name" data-index="${i}" autocomplete="off"></div>
<div class="rb__field"><label>Age</label><select required data-rb-field="camper_age" data-index="${i}"><option value="">Age</option>${kidAgeList().map(age => `<option>${age}</option>`).join('')}</select></div>
<div class="rb__field rb__field--wide"><label>Emergency contact</label><input required data-rb-field="emergency_contact_name" data-index="${i}" autocomplete="off"></div>
<div class="rb__field rb__field--wide"><label>Phone</label><input required data-rb-field="emergency_contact_phone_number" data-index="${i}" type="tel" inputmode="tel" autocomplete="tel" placeholder="+1 (516) 555-1234"></div>
<div class="rb__field rb__field--wide"><label>Allergies or medical considerations</label><textarea data-rb-field="allergies_or_medical_considerations" data-index="${i}"></textarea></div>
</div>
</div>`);
} else {
const heading = config.freeHold ? "Who's coming" : (config.isParty ? 'Party contact' : (quantity === 1 ? (quantityLabel() === 'Person' ? "Who's coming" : quantityLabel()) : quantityLabel() + ' ' + (i + 1)));
const nameLabel = config.freeHold ? 'Name' : (config.isParty ? 'Parent/guardian name' : (quantityLabel() === 'Person' ? 'Name' : quantityLabel() + ' name'));
cards.push(`
<div class="rb__person" data-rb-person="${i}">
<h3>${heading}</h3>
<div class="rb__fields">
<div class="rb__field rb__field--wide"><label>${nameLabel}</label><input required data-rb-field="guest_name" data-index="${i}" autocomplete="name"></div>
<div class="rb__field rb__field--wide"><label>Email</label><input required type="email" data-rb-field="guest_email" data-index="${i}" autocomplete="email" placeholder="name@email.com"></div>
<div class="rb__field rb__field--wide"><label>Phone</label><input required data-rb-field="guest_phone" data-index="${i}" type="tel" inputmode="tel" autocomplete="tel" placeholder="+1 (516) 555-1234"></div>
</div>
</div>`);
}
}
peopleEl.innerHTML = cards.join('');
restorePeopleFields(fieldSnap);
if (config.leadOnly) {
const lead = peopleEl.querySelector('[data-rb-field="guest_name"]');
const g1 = peopleEl.querySelector('[data-rb-field="guest1_name"]');
if (lead && g1) {
if (!g1.value && lead.value) g1.value = lead.value.trim().split(/\s+/)[0];
lead.addEventListener('input', () => { if (g1.dataset.rbTouched !== '1') g1.value = lead.value.trim().split(/\s+/)[0]; });
g1.addEventListener('input', event => { if (event.isTrusted) g1.dataset.rbTouched = '1'; });
}
}
bindPhoneInputs();
bindEmailInputs();
};
const selectedTitle = () => {
const selected = selectedSessions();
if (config.freeHold) {
if (!dateInput?.value) return 'Choose a date';
if (!selected.length) return 'Choose a time';
return fmtTime(selected[0].start);
}
if (!selected.length) return 'Choose a date';
if (selected.length === 1) return cleanName(selected[0].name);
return `${selected.length} weeks selected`;
};
const selectedMeta = selected => {
if (!selected.length) {
if (config.freeHold) return dateInput?.value ? `${fmtDateValue(dateInput.value)} · times available` : 'Times appear after you choose a date.';
if (!sessions.length) return 'Checking the calendar…';
const waitlistCount = sessions.filter(waitlistSession).length;
if (waitlistCount && !sessions.some(availableSession)) return `${waitlistCount} waitlist sessions`;
return config.isCamp ? 'Weeks available' : 'Sessions available';
}
if (selected.length === 1) {
const session = selected[0];
if (config.freeHold) return `${fmtDateValue(dateValueInZone(session.start))} · ${sessionStatus(session)}`;
return `${sessionMetaText(session)} · ${waitlistSession(session) ? 'Waitlist only' : sessionStatus(session)}`;
}
return selected.map(session => `${cleanName(session.name)} (${fmtRange(session)})`).join(', ');
};
const visibleRequiredFieldsReady = () => {
const fields = [...form.querySelectorAll('input, select, textarea')].filter(el => {
if (!el.required || el.disabled) return false;
if (el.type === 'hidden' || el.hidden) return false;
const style = window.getComputedStyle(el);
if (style.display === 'none' || style.visibility === 'hidden') return false;
return !!el.closest('.rb__form') && !el.closest('[hidden]');
});
return fields.every(el => el.checkValidity());
};
const policyReady = () => {
const selected = selectedSessions();
if (selectionIsWaitlist(selected)) return true;
if (kidMode() && selected.some(availableSession)) return !!waiverAccepted;
return !policyAccept || policyAccept.checked;
};
const syncActionButtonsCore = () => {
const selected = selectedSessions();
const waitlistOnly = selectionIsWaitlist(selected);
const mixedMode = selectionIsMixed(selected);
const hasWaitlist = selectionHasWaitlist(selected);
if (config.freeHold) {
const ready = selected.length > 0 && selected.every(session => availableSession(session)) && visibleRequiredFieldsReady();
submit.textContent = 'Reserve';
submit.disabled = !ready;
if (buynow) { buynow.hidden = true; buynow.disabled = true; }
return;
}
const reservableReady = selected.length > 0 && selected.every(session => waitlistSession(session) || (availableSession(session) && Number(session.available || 0) >= (config.projectQuantityMode ? Math.max(1, projectQuantity(session)) : quantity)));
const requiredReady = visibleRequiredFieldsReady() && policyReady();
if (mixedMode) {
submit.textContent = 'Add to cart + join waitlist';
submit.disabled = !(reservableReady && requiredReady);
if (buynow) { buynow.hidden = true; buynow.disabled = true; }
return;
}
if (waitlistOnly) {
submit.textContent = 'Join the waitlist';
submit.disabled = !(selected.length && requiredReady);
if (buynow) { buynow.hidden = true; buynow.disabled = true; }
return;
}
submit.textContent = 'Add to cart';
submit.disabled = !(reservableReady && requiredReady && !hasWaitlist);
if (buynow) { buynow.hidden = false; buynow.disabled = submit.disabled; }
};
const missingBits = () => {
const bits = [];
if (!config.isEventProduct && config.recurringMode && !selectedLocationId && btaLocations().length > 1) bits.push({ label: 'pick a studio', target: '.rb__studio-group' });
const selected = selectedSessions();
if (!selected.length) bits.push({ label: config.isEventProduct ? 'choose a piece' : (config.isCamp ? 'choose a week' : 'pick a date'), target: '.rb__field-group--sessions' });
if (!visibleRequiredFieldsReady()) bits.push({ label: 'finish your details', target: '.rb__people-list' });
if (!policyReady()) bits.push({ label: kidMode() ? 'acknowledge the waiver' : 'agree to the waiver', target: '[data-rb-waiver-card]' });
return bits;
};
const renderMissing = () => {
if (!missingEl) return;
if (!submit.disabled) { missingEl.hidden = true; return; }
const bits = missingBits();
if (!bits.length) { missingEl.hidden = true; return; }
missingEl.hidden = false;
missingEl.innerHTML = 'Before you can ' + (config.freeHold ? 'reserve' : 'add to cart') + ': ' + bits.map(bit => `<button type="button" data-rb-missing-jump="${esc(bit.target)}">${esc(bit.label)}</button>`).join(' &middot; ') + '.';
};
if (missingEl) missingEl.addEventListener('click', event => {
const jump = event.target.closest('[data-rb-missing-jump]');
if (!jump) return;
const target = root.querySelector(jump.dataset.rbMissingJump);
if (!target) return;
target.scrollIntoView({ behavior: 'smooth', block: 'center' });
target.classList.remove('rb__flash');
void target.offsetWidth;
target.classList.add('rb__flash');
});
const syncActionButtons = () => {
syncActionButtonsCore();
if (config.leadOnly) root.classList.toggle('rb--no-session', !selectedSessions().length);
if (waiverCardEl) waiverCardEl.classList.toggle('is-accepted', kidMode() ? !!waiverAccepted : !!(policyAccept && policyAccept.checked));
renderMissing();
};
const updateSummary = () => {
syncShipUI(selectedSessions());
if (config.projectQuantityMode) {
renderPeople();
const selected = selectedSessions();
const waitlisted = waitlistSelections(selected);
const reservable = reservableSelections(selected);
const totalQty = totalProjectQuantity();
const reservableQty = reservable.reduce((sum, session) => sum + projectQuantity(session), 0);
const waitlistMode = waitlisted.length > 0;
const waitlistOnly = selectionIsWaitlist(selected);
const mixedMode = selectionIsMixed(selected);
syncWaitlistChrome(selected);
const ready = reservable.length > 0 && reservable.every(session => Number(session.available || 0) >= projectQuantity(session));
const actionable = selected.length > 0 && (ready || waitlistMode);
const itemNoun = config.isEventProduct ? 'piece' : (config.isCamp ? 'week' : 'project');
const personNoun = quantityNoun();
const selectedName = selected.length === 1 ? (config.isCamp ? cleanName(selected[0].name) : projectName(selected[0])) : '';
if (sessionTitle) sessionTitle.textContent = selected.length === 1 ? selectedName : (selected.length ? `${selected.length} ${itemNoun}s selected` : (config.isCamp ? 'Choose a date' : (config.isEventProduct ? 'Choose a piece' : 'Choose a date')));
if (sessionMeta) sessionMeta.textContent = selected.length === 1 ? selectedMeta(selected) : (selected.length ? `${reservableQty} ${reservableQty === 1 ? personNoun : personNoun + 's'} reserving${waitlisted.length ? ` · ${waitlisted.length} waitlist` : ''}` : 'Live availability');
if (sessionCount) sessionCount.textContent = String(totalQty);
if (availabilityNote) availabilityNote.textContent = selected.length ? (mixedMode ? 'Reserve + waitlist' : (waitlistMode ? 'Waitlist' : 'Live availability')) : '';
totalLabel.textContent = waitlistOnly ? `${selectedName || pluralize(waitlisted.length, itemNoun)} waitlist` : (config.isEventProduct && !mixedMode ? (totalQty ? `${totalQty} ${totalQty === 1 ? 'piece' : 'pieces'}` : '') : mixedMode ? `${reservableQty} ${reservableQty === 1 ? personNoun : personNoun + 's'} reserving · ${waitlisted.length} waitlist` : (totalQty ? `${totalQty} ${totalQty === 1 ? personNoun : personNoun + 's'} across ${selected.length} ${selected.length === 1 ? itemNoun : itemNoun + 's'}` : ''));
const eventTotalCents = config.isEventProduct ? reservable.reduce((sum, session) => {
const variant = config.variantMap[String(session.externalId)];
return sum + (Number(variant?.price || 0) * projectQuantity(session));
}, 0) : 0;
const purchaseTotalText = config.isEventProduct ? money(eventTotalCents) : money(priceCents() * reservableQty);
total.textContent = waitlistOnly ? 'Waitlist' : (mixedMode ? `${purchaseTotalText} + waitlist` : purchaseTotalText);
if (config.isEventProduct) {
if (eventWaitlistCard) eventWaitlistCard.hidden = !waitlistMode;
const eventWaitlistOk = !waitlistMode || ((eventWaitlistName?.value || '').trim().length >= 2 && validEmail(normalizeEmail(eventWaitlistEmail?.value || '')) && normalizePhone(eventWaitlistPhone?.value || '').valid);
const eventPolicyOk = waitlistOnly || !policyAccept || policyAccept.checked;
submit.disabled = !((ready && eventPolicyOk) || (waitlistMode && eventWaitlistOk));
syncActionButtons();
return;
}
syncActionButtons();
return;
}
clampQuantity();
renderPeople();
const selected = selectedSessions();
const waitlistMode = selectionIsWaitlist(selected);
syncWaitlistChrome(selected);
const ready = selected.length > 0 && selected.every(session => availableSession(session) && Number(session.available || 0) >= quantity);
sessionTitle.textContent = selectedTitle();
sessionMeta.textContent = selectedMeta(selected);
sessionCount.textContent = String(selected.length);
if (availabilityNote) availabilityNote.textContent = selected.length ? (waitlistMode ? 'Waitlist' : 'Live availability') : '';
if (selected.length) {
const first = selected[0];
if (stageTitle) stageTitle.textContent = (config.recurringMode && !config.freeHold && first.start) ? `${fmtDayLong(first.start)} · ${fmtTime(first.start)}–${fmtTime(first.finish)}` : cleanName(first.name);
if (stageNote) stageNote.textContent = config.isCamp ? (themeNotes[themeKey(first.name)] || 'A themed camp week with pottery, guided art projects, sensory activities, and studio games.') : sessionMetaText(first);
}
const peopleText = pluralize(quantity, quantityNoun());
if (config.isParty) {
totalLabel.textContent = 'Due today';
total.textContent = '$200';
} else {
totalLabel.textContent = selected.length ? (waitlistMode ? `${peopleText} on waitlist` : `${peopleText} × ${selected.length} ${config.isCamp ? (selected.length === 1 ? 'week' : 'weeks') : (selected.length === 1 ? 'session' : 'sessions')}`) : '';
if (config.leadOnly && selected.length && !waitlistMode) {
totalLabel.textContent = `${peopleText} · ${groupBreakdown()}`;
total.textContent = money(groupTotalCents());
} else {
total.textContent = waitlistMode ? 'Waitlist' : money(priceCents() * quantity * Math.max(1, selected.length));
}
}
syncActionButtons();
if (config.freeHold) {
if (buynow) { buynow.hidden = true; buynow.disabled = true; }
const groupTitle = selectedFhGroupTitle();
syncActionButtons();
totalLabel.textContent = selected.length ? `${fhLongDateShort(selected[0].start)}${groupTitle ? ' · ' + groupTitle : ''}` : '';
total.textContent = '';
}
};
const fhLongDateShort = iso => iso ? new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', timeZone: config.timeZone }).format(new Date(iso)) : '';
const scrollToLearnPanel = event => {
if (!learnPanel) return;
event?.preventDefault();
requestAnimationFrame(() => {
const stickyTop = parseInt(getComputedStyle(root).getPropertyValue('--rb-sticky-top'), 10) || 34;
const rect = learnPanel.getBoundingClientRect();
const desktop = window.matchMedia('(min-width: 921px)').matches;
const stage = root.querySelector('.rb__stage');
const hero = root.querySelector('.rb__hero');
const desiredTop = Math.max(
stickyTop + 14,
Math.round((window.innerHeight - Math.min(rect.height, window.innerHeight * 0.58)) / 2)
);
let targetY = rect.top + window.scrollY - desiredTop;
if (desktop && stage && hero && root.classList.contains('rb--stage-sticky')) {
const heroRect = hero.getBoundingClientRect();
const stageRect = stage.getBoundingClientRect();
const panelOffset = rect.top - stageRect.top;
const heroBottom = heroRect.bottom + window.scrollY;
targetY = heroBottom - stageRect.height + panelOffset - desiredTop;
}
window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
});
};
const words = { zero:'0', oh:'0', o:'0', one:'1', two:'2', three:'3', four:'4', five:'5', six:'6', seven:'7', eight:'8', nine:'9' };
const normalizeEmail = value => String(value || '').trim().toLowerCase();
const validEmail = value => {
const email = normalizeEmail(value);
return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) && !email.includes('..') && !email.endsWith('.');
};
const bindEmailInputs = () => {
peopleEl.querySelectorAll('input[type="email"]').forEach(input => {
input.addEventListener('blur', () => {
input.value = normalizeEmail(input.value);
input.setCustomValidity(!input.value || validEmail(input.value) ? '' : 'Enter a valid email address, like name@email.com.');
});
input.addEventListener('input', () => input.setCustomValidity(''));
});
};
const phoneDigits = value => String(value || '').toLowerCase().replace(/\b(zero|oh|o|one|two|three|four|five|six|seven|eight|nine)\b/g, m => words[m] || '').replace(/\D/g, '');
const normalizePhone = value => {
let digits = phoneDigits(value);
if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
if (digits.length !== 10) return { valid: false, formatted: value, digits };
if (digits[0] === '0' || digits[0] === '1' || digits[3] === '0' || digits[3] === '1') return { valid: false, formatted: value, digits };
return { valid: true, digits: '1' + digits, formatted: `+1 (${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}` };
};
const bindPhoneInputs = () => {
peopleEl.querySelectorAll('input[inputmode="tel"]').forEach(input => {
input.addEventListener('blur', () => {
const result = normalizePhone(input.value);
if (result.valid) {
input.value = result.formatted;
input.setCustomValidity('');
} else if (input.value.trim()) {
input.setCustomValidity('Use a U.S. phone number with area code.');
}
});
input.addEventListener('input', () => input.setCustomValidity(''));
});
};
const collectWaitlistContact = () => {
const card = peopleEl.querySelector('[data-rb-waitlist-contact]');
const person = {};
if (!card) return person;
card.querySelectorAll('[data-rb-field]').forEach(input => { person[input.dataset.rbField] = (input.value || '').trim(); });
return person;
};
const collectPeople = () => {
if (config.projectQuantityMode) {
const bySession = {};
const selected = selectedSessions();
selected.forEach(session => {
bySession[session.key] = [];
peopleEl.querySelectorAll(`[data-rb-project-person][data-session-key="${session.key}"]`).forEach(card => {
const person = {};
card.querySelectorAll('[data-rb-field]').forEach(input => { person[input.dataset.rbField] = (input.value || '').trim(); });
bySession[session.key].push(person);
});
});
if (config.miniSeries && miniSeriesMirror && selected.length) {
const lead = bySession[selected[0].key] || [];
selected.slice(1).forEach(session => { bySession[session.key] = lead.map(person => Object.assign({}, person)); });
}
return { bySession };
}
const people = [];
for (let i = 0; i < peopleCount(); i++) {
const card = peopleEl.querySelector(`[data-rb-person="${i}"]`);
const person = {};
card.querySelectorAll('[data-rb-field]').forEach(input => { person[input.dataset.rbField] = (input.value || '').trim(); });
people.push(person);
}
return people;
};
const validate = () => {
const selected = selectedSessions();
if (!selected.length) throw new Error(config.isEventProduct ? 'Choose at least one piece.' : (config.projectQuantityMode ? 'Choose at least one project date.' : (config.isCamp ? 'Choose at least one week.' : 'Choose a session.')));
if (config.isEventProduct) {
if (selectionIsWaitlist(selected)) {
const name = (eventWaitlistName?.value || '').trim();
const email = normalizeEmail(eventWaitlistEmail?.value || '');
const phone = normalizePhone(eventWaitlistPhone?.value || '');
if (name.length < 2) throw new Error('Add your name to join the waitlist.');
if (!validEmail(email)) throw new Error('Enter a valid email to join the waitlist.');
if (!phone.valid) throw new Error('Enter a U.S. phone number with area code to join the waitlist.');
return { selected, people: { [selected[0].key]: [{ guest_name: name, guest_email: email, guest_phone: phone.formatted }] } };
}
if (policyAccept && !policyAccept.checked) {
throw new Error('Check the required waiver acknowledgement before reserving.');
}
return { selected, people: {} };
}
const people = collectPeople();
if (config.projectQuantityMode) {
const hasReservable = selectionHasReservable(selected);
selected.forEach(session => {
const rows = people.bySession[session.key] || [];
const sessionName = config.isCamp ? cleanName(session.name) : projectName(session);
if (waitlistSession(session)) {
const contact = rows[0] || {};
contact.guest_email = normalizeEmail(contact.guest_email);
const phone = normalizePhone(contact.guest_phone);
if (!contact.guest_name || contact.guest_name.length < 2) throw new Error(`${sessionName}: add your name to join the waitlist.`);
if (!validEmail(contact.guest_email)) throw new Error(`${sessionName}: enter a valid email to join the waitlist.`);
if (!phone.valid) throw new Error(`${sessionName}: enter a U.S. phone number with area code to join the waitlist.`);
contact.guest_phone = phone.formatted;
people.bySession[session.key] = [contact];
return;
}
const personNoun = quantityNoun();
if (rows.length !== projectQuantity(session)) throw new Error(`${sessionName}: add ${personNoun} details.`);
rows.forEach((person, index) => {
const label = projectQuantity(session) === 1 ? `${sessionName} ${personNoun}` : `${sessionName} ${personNoun} ${index + 1}`;
if (kidMode()) {
if (!person.camper_name) throw new Error(`${label}: add ${kidLabel().toLowerCase()} name.`);
if (!person.camper_age) throw new Error(`${label}: choose ${kidLabel().toLowerCase()} age.`);
if (!person.emergency_contact_name) throw new Error(`${label}: add parent/guardian name.`);
const phone = normalizePhone(person.emergency_contact_phone_number);
if (!phone.valid) throw new Error(`${label}: enter a U.S. parent/guardian phone number with area code.`);
person.emergency_contact_phone_number = phone.formatted;
} else {
if (!person.guest_name) throw new Error(`${label}: add a name.`);
person.guest_email = normalizeEmail(person.guest_email);
if (!validEmail(person.guest_email)) throw new Error(`${label}: enter a valid email address.`);
const phone = normalizePhone(person.guest_phone);
if (!phone.valid) throw new Error(`${label}: enter a U.S. phone number with area code.`);
person.guest_phone = phone.formatted;
}
});
});
if (hasReservable && kidMode()) {
if (!waiverAccepted) throw new Error('Review and acknowledge the waiver before checkout.');
} else if (hasReservable && policyAccept && !policyAccept.checked) {
throw new Error('Check the required waiver acknowledgement before reserving.');
}
return { selected, people: people.bySession };
}
if (selectionIsWaitlist(selected)) {
const contact = collectWaitlistContact();
contact.guest_email = normalizeEmail(contact.guest_email);
const phone = normalizePhone(contact.guest_phone);
if (!contact.guest_name || contact.guest_name.length < 2) throw new Error('Add your name to join the waitlist.');
if (!validEmail(contact.guest_email)) throw new Error('Enter a valid email to join the waitlist.');
if (!phone.valid) throw new Error('Enter a U.S. phone number with area code to join the waitlist.');
contact.guest_phone = phone.formatted;
return { selected, people: [contact] };
}
people.forEach((person, index) => {
const label = kidMode() ? (quantity === 1 ? kidLabel() : `${kidLabel()} ${index + 1}`) : (quantity === 1 ? quantityLabel() : `${quantityLabel()} ${index + 1}`);
if (kidMode()) {
if (!person.camper_name) throw new Error(`${label}: add ${kidLabel().toLowerCase()} name.`);
if (!person.camper_age) throw new Error(`${label}: choose ${kidLabel().toLowerCase()} age.`);
if (!person.emergency_contact_name) throw new Error(`${label}: add emergency contact name.`);
const phone = normalizePhone(person.emergency_contact_phone_number);
if (!phone.valid) throw new Error(`${label}: enter a U.S. emergency phone number with area code.`);
person.emergency_contact_phone_number = phone.formatted;
} else {
if (!person.guest_name) throw new Error(config.isParty ? 'Add parent/guardian name.' : `${label}: add ${quantityNoun() === 'person' ? 'a' : quantityNoun()} name.`);
person.guest_email = normalizeEmail(person.guest_email);
if (!validEmail(person.guest_email)) throw new Error(`${label}: enter a valid email address.`);
const phone = normalizePhone(person.guest_phone);
if (!phone.valid) throw new Error(`${label}: enter a U.S. phone number with area code.`);
person.guest_phone = phone.formatted;
if (config.leadOnly) {
for (let g = 1; g <= quantity; g++) {
if (!person[`guest${g}_name`]) throw new Error(`Guest ${g}: add a first name.`);
if (!person[`guest${g}_age`]) throw new Error(`Guest ${g}: choose an age.`);
}
}
}
});
if (kidMode()) {
if (!waiverAccepted) throw new Error('Review and acknowledge the waiver before checkout.');
} else if (policyAccept && !policyAccept.checked) {
throw new Error('Check the required waiver acknowledgement before reserving.');
}
return { selected, people };
};
const fhSplitName = fullName => {
const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
return { firstName: parts.shift() || '', lastName: parts.join(' ') };
};
const fhEncodeForm = (value, prefix, params) => {
params = params || new URLSearchParams();
if (Array.isArray(value)) {
value.forEach((item, index) => fhEncodeForm(item, `${prefix}[${index}]`, params));
} else if (value && typeof value === 'object') {
Object.entries(value).forEach(([key, item]) => fhEncodeForm(item, prefix ? `${prefix}[${key}]` : key, params));
} else if (prefix) {
params.append(prefix, value == null ? '' : String(value));
}
return params;
};
const fhContact = people => {
const arr = Array.isArray(people) ? people : [];
const first = arr[0] || {};
return { name: first.guest_name || '', email: first.guest_email || '', phone: first.guest_phone || '' };
};
const fhLongDate = iso => iso ? new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', timeZone: config.timeZone }).format(new Date(iso)) : '';
const fhTimeRange = session => `${fmtTime(session.start)} - ${fmtTime(session.finish)}`;
const createDirectBooking = async (selected, people) => {
const session = selected[0];
const contact = fhContact(people);
const { firstName, lastName } = fhSplitName(contact.name);
const groupTitle = selectedFhGroupTitle();
const btaVariant = selectedBtaVariant();
const payload = {
starts_at: session.start,
finishes_at: session.finish,
location_id: Number(selectedLocationId || config.locationId || '54127'),
source: 'via_standalone',
items: [{ resource_id: '', external_id: String(btaVariant.external_id || selectedFhVariantId || config.variantId), quantity: 1 }],
customers: [{ first_name: firstName, last_name: lastName, email: contact.email, phone: contact.phone || '' }],
fields: [
{ name: 'Reservation type', value: config.experienceLabel || 'Open Studio reservation' },
{ name: 'Reservation note', value: config.experienceHelp || '' },
{ name: 'Group size', value: groupTitle }
],
tags: ['open_studio_reservation', config.experienceTag || 'open_studio'],
shop: config.btaShop
};
const res = await fetch('/apps/bookthatapp/api/v1/bookings', {
method: 'POST',
headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
body: fhEncodeForm(payload).toString()
});
const data = await res.json().catch(() => ({}));
if (!res.ok) {
const message = Array.isArray(data?.errors) ? (data.errors[0]?.messages || data.errors[0]?.message) : (data?.message || data?.errors || data?.error);
throw new Error(message || 'BookThatApp could not create this reservation.');
}
return data;
};
const showFreeHoldConfirmation = (selected, people) => {
const session = selected[0];
const contact = fhContact(people);
const groupTitle = selectedFhGroupTitle();
const summary = `${fhLongDate(session.start)} · ${fhTimeRange(session)}${groupTitle ? ' · ' + groupTitle : ''}`;
setStatus('Table reserved. Confirmation is being sent to your email.', 'ok');
root.querySelector('[data-rb-fh-confirm-modal]')?.remove();
const modal = document.createElement('div');
modal.className = 'rb__fh-confirm-modal';
modal.setAttribute('role', 'dialog');
modal.setAttribute('aria-modal', 'true');
modal.setAttribute('aria-labelledby', 'rb-fh-confirm-title-' + sectionId);
modal.setAttribute('data-rb-fh-confirm-modal', '');
modal.innerHTML = `
<div class="rb__fh-confirm-scrim" data-rb-fh-confirm-close></div>
<div class="rb__fh-confirm" role="document">
<button type="button" class="rb__fh-confirm-close" data-rb-fh-confirm-close aria-label="Close confirmation">×</button>
<p class="rb__fh-confirm-kicker">Table reserved</p>
<h3 id="rb-fh-confirm-title-${sectionId}">You're reserved.</h3>
<p><strong>${esc(summary)}</strong></p>
<p>Confirmation is being sent to <strong>${esc(contact.email)}</strong>.</p>
<div class="rb__fh-confirm-actions">
<button type="button" class="rb__button" data-rb-fh-confirm-close>Done</button>
</div>
</div>
`;
const close = () => {
modal.remove();
submit?.focus({ preventScroll: true });
document.removeEventListener('keydown', onKeydown);
};
const onKeydown = event => { if (event.key === 'Escape') close(); };
modal.addEventListener('wheel', event => event.preventDefault(), { passive: false });
modal.addEventListener('touchmove', event => event.preventDefault(), { passive: false });
modal.querySelectorAll('[data-rb-fh-confirm-close]').forEach(button => button.addEventListener('click', close));
root.appendChild(modal);
document.addEventListener('keydown', onKeydown);
modal.querySelector('.rb__fh-confirm-close')?.focus({ preventScroll: true });
};
const getCartToken = async () => {
const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
const cart = await res.json();
return cart?.token || `eaps-bta-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};
const createReservation = async (cartToken, selected) => {
const body = new URLSearchParams();
body.set('cart_token', cartToken);
let resIndex = 0;
const pushItem = (session, externalId, qty) => {
const index = resIndex++;
body.set(`items[${index}][externalId]`, String(externalId));
body.set(`items[${index}][quantity]`, String(qty));
if (session.start) body.set(`items[${index}][start]`, session.start);
if (session.finish) body.set(`items[${index}][finish]`, session.finish);
body.set(`items[${index}][location_name]`, sessionLocationName(session));
if (session.locationId) body.set(`items[${index}][location_id]`, String(session.locationId));
};
selected.forEach(session => {
if (config.leadOnly) {
if (config.perSeat) { pushItem(session, groupBaseId(), quantity); return; }
pushItem(session, groupBaseId(), 1);
if (groupExtras() > 0 && groupAddonId()) pushItem(session, groupAddonId(), groupExtras());
return;
}
pushItem(session, session.externalId || config.variantId, config.projectQuantityMode ? projectQuantity(session) : quantity);
});
body.set('check_waitlist', 'true');
body.set('check_expires', '');
body.set('shop', config.btaShop);
const attempt = async retryFlag => {
body.set('retry', retryFlag ? 'true' : 'false');
const res = await fetch('/apps/bookthatapp/api/v1/reservations', {
method: 'POST',
headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
body: body.toString()
});
const data = await res.json().catch(() => ({}));
if (!res.ok) throw new Error(data?.message || 'Online booking could not reserve this selection.');
return data.reservation || data;
};
let reservation = await attempt(false);
let bad = (reservation.items || []).find(item => item.status && item.status !== 'ok');
if (bad && String(bad.status) === 'booking_conflict') {
// Stale hold tied to this cart token (abandoned earlier attempt) - ask BTA to replace it.
reservation = await attempt(true);
bad = (reservation.items || []).find(item => item.status && item.status !== 'ok');
}
if (bad) throw new Error(`Online booking is not available right now (${String(bad.status).replace(/_/g, ' ')}).`);
return reservation;
};
const addToCart = async (reservation, cartToken, selected, people) => {
if (config.projectQuantityMode) {
const items = selected.map((session, index) => {
const reservationItem = (reservation?.items || [])[index] || {};
const props = {};
(people[session.key] || []).forEach((person, studentIndex) => {
const suffix = studentIndex === 0 ? '' : `-${studentIndex + 1}`;
if (kidMode()) {
props[`${kidLabel()} name${suffix}`] = person.camper_name;
props[`${kidLabel()} age${suffix}`] = person.camper_age;
props[`Parent/guardian${suffix}`] = person.emergency_contact_name;
props[`Parent/guardian phone${suffix}`] = person.emergency_contact_phone_number;
if (person.allergies_or_medical_considerations) props[`Allergies or medical considerations${suffix}`] = person.allergies_or_medical_considerations;
} else {
props[`Name${suffix}`] = person.guest_name;
props[`Email${suffix}`] = person.guest_email;
props[`Phone${suffix}`] = person.guest_phone;
}
});
return {
id: config.isEventProduct ? Number(session.externalId || config.variantId) : sessionCartVariantId(session),
quantity: projectQuantity(session),
properties: {
'Project': config.isCamp ? cleanName(session.name) : projectName(session),
'Session': `${config.isCamp ? cleanName(session.name) : projectName(session)} - ${fmtRange(session)} ${fmtTime(session.start)}-${fmtTime(session.finish)}`,
'Start': fmtLong(session.start),
'_start_iso8601': session.start || '',
'Finish': fmtLong(session.finish),
'_finish_iso8601': session.finish || '',
'Location': sessionLocationName(session),
'Policy accepted': kidMode() ? `Waiver accepted by parent/guardian ${waiverAccepted.name}` : 'EAPS Waiver and Participation Agreement accepted',
'Policy accepted at': kidMode() ? waiverAccepted.timestamp : new Date().toISOString(),
'_BTA reservation ID': reservation?.id || '',
'_BTA reservation item ID': reservationItem.id || '',
'_BTA cart token': cartToken,
'_BTA term ID': session.termId ? String(session.termId) : '',
'_BTA variant external ID': String(session.externalId || config.variantId),
'_BTA product external ID': String(config.productId),
'_BTA profile': btaProduct?.profile || '',
...props
}
};
});
const shipItem = shippingCartItem(selected, people);
if (shipItem) items.push(shipItem);
const res = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items })
});
const data = await res.json().catch(() => ({}));
if (!res.ok) throw new Error(data?.description || data?.message || 'Could not add this reservation to cart.');
return data;
}
const sharedPeopleProperties = {};
people.forEach((person, index) => {
const suffix = index === 0 ? '' : `-${index + 1}`;
if (kidMode()) {
sharedPeopleProperties[`${kidLabel()} name${suffix}`] = person.camper_name;
sharedPeopleProperties[`${kidLabel()} age${suffix}`] = person.camper_age;
sharedPeopleProperties[`Emergency contact name${suffix}`] = person.emergency_contact_name;
sharedPeopleProperties[`Emergency contact phone number${suffix}`] = person.emergency_contact_phone_number;
sharedPeopleProperties[`Allergies or medical considerations${suffix}`] = person.allergies_or_medical_considerations || 'None provided';
} else {
sharedPeopleProperties[`Name${suffix}`] = person.guest_name;
sharedPeopleProperties[`Email${suffix}`] = person.guest_email;
sharedPeopleProperties[`Phone${suffix}`] = person.guest_phone;
if (config.leadOnly) {
sharedPeopleProperties['Group size'] = String(quantity);
if (!config.perSeat) sharedPeopleProperties['Additional people'] = String(groupExtras());
for (let g = 1; g <= quantity; g++) {
const age = person[`guest${g}_age`];
sharedPeopleProperties[`Guest ${g}`] = `${person[`guest${g}_name`] || ''}${age ? ` · ${age === 'Adult' ? 'Adult' : 'age ' + age}` : ''}`;
}
}
}
});
const items = selected.map((session, index) => {
const reservationItem = (reservation?.items || [])[(config.leadOnly && !config.perSeat) ? index * 2 : index] || {};
const sessionKind = config.isCamp ? 'Week' : 'Session';
const properties = {
[sessionKind]: `${cleanName(session.name)} - ${fmtRange(session)} ${fmtTime(session.start)}-${fmtTime(session.finish)}`,
'Start': fmtLong(session.start),
'_start_iso8601': session.start || '',
'Finish': fmtLong(session.finish),
'_finish_iso8601': session.finish || '',
'Location': sessionLocationName(session),
'Policy accepted': kidMode() ? `Waiver accepted by parent/guardian ${waiverAccepted.name}` : 'EAPS Waiver and Participation Agreement accepted',
'Policy accepted at': kidMode() ? waiverAccepted.timestamp : new Date().toISOString(),
'_BTA reservation ID': reservation?.id || '',
'_BTA reservation item ID': reservationItem.id || '',
'_BTA cart token': cartToken,
'_BTA term ID': session.termId ? String(session.termId) : '',
'_BTA variant external ID': String(session.externalId || config.variantId),
'_BTA product external ID': String(config.productId),
'_BTA profile': btaProduct?.profile || '',
...sharedPeopleProperties
};
if (config.leadOnly) {
if (config.perSeat) return [{ id: groupBaseId(), quantity, properties }];
const addonItem = (reservation?.items || [])[index * 2 + 1] || {};
const baseLine = { id: groupBaseId(), quantity: 1, properties };
if (groupExtras() > 0 && groupAddonId()) {
const addonProps = {
[sessionKind]: properties[sessionKind],
'Start': properties['Start'], '_start_iso8601': properties['_start_iso8601'],
'Finish': properties['Finish'], '_finish_iso8601': properties['_finish_iso8601'],
'Location': properties['Location'],
'Add-on for': `${config.productTitle || 'Throw Together'} group of ${minQuantity()}`,
'Booking contact': people[0]?.guest_name || '',
'_BTA reservation ID': reservation?.id || '',
'_BTA reservation item ID': addonItem.id || '',
'_BTA cart token': cartToken,
'_BTA variant external ID': String(groupAddonId()),
'_BTA product external ID': String(config.productId),
'_BTA profile': btaProduct?.profile || ''
};
return [baseLine, { id: groupAddonId(), quantity: groupExtras(), properties: addonProps }];
}
return [baseLine];
}
return { id: sessionCartVariantId(session), quantity, properties };
}).flat();
const shipItem = shippingCartItem(selected, people);
if (shipItem) items.push(shipItem);
const res = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items })
});
const data = await res.json().catch(() => ({}));
if (!res.ok) throw new Error(data?.description || data?.message || 'Could not add this reservation to cart.');
return data;
};
const joinWaitlist = async (selected, people) => {
const waitlisted = selected.filter(waitlistSession);
const waitlistProductId = btaProduct?.external_id || btaProduct?.externalId || config.productId;
const results = [];
for (const session of waitlisted) {
const contact = config.projectQuantityMode ? ((people[session.key] || [])[0] || {}) : (people[0] || {});
const body = new URLSearchParams();
body.set('email', contact.guest_email || '');
body.set('phone', contact.guest_phone || '');
body.set('name', contact.guest_name || '');
body.set('customer[email]', contact.guest_email || '');
body.set('customer[phone]', contact.guest_phone || '');
body.set('customer[name]', contact.guest_name || '');
body.set('customer_email', contact.guest_email || '');
body.set('customer_phone', contact.guest_phone || '');
body.set('customer_name', contact.guest_name || '');
body.set('quantity', String(config.projectQuantityMode ? projectQuantity(session) : quantity));
body.set('external_variant_id', String(session.externalId || config.variantId));
if (session.locationId) body.set('location_id', String(session.locationId));
if (session.start) body.set('starts_at', session.start);
if (session.finish) body.set('finishes_at', session.finish);
body.set('shop', config.btaShop);
const res = await fetch(`/apps/bookthatapp/api/v1/products/${encodeURIComponent(waitlistProductId)}/waitlist`, {
method: 'POST',
headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
body: body.toString()
});
const data = await res.json().catch(() => ({}));
if (!res.ok) {
const details = data?.errors ? Object.values(data.errors).flat().join(' ') : '';
throw new Error(details || data?.message || `Could not add ${cleanName(session.name) || 'that session'} to the waitlist.`);
}
results.push(data);
}
return results;
};
const checkWaiverReady = () => {
if (!waiverName || !waiverSubmit) return;
waiverName.disabled = !waiverScrolled;
waiverName.placeholder = waiverScrolled ? (kidMode() ? 'Type parent or guardian name' : 'Type your name') : 'Scroll through the agreement first';
const hasName = (waiverName.value || '').trim().length >= 2;
waiverSubmit.disabled = !(waiverScrolled && hasName);
};
const loadWaiver = async () => {
if (waiverLoaded) return;
waiverLoaded = true;
try {
const res = await fetch(config.waiverUrl, { headers: { 'Accept': 'text/html' } });
const html = await res.text();
const doc = new DOMParser().parseFromString(html, 'text/html');
doc.querySelectorAll('script, style, noscript, iframe, form, input, button, select, textarea').forEach(node => node.remove());
const main = doc.querySelector('.ea-waiver-formatted, .ea-pagecontent__legal .ea-pagecontent__body, main') || doc.body;
main.querySelectorAll('a[href^="/"]').forEach(link => { link.href = link.getAttribute('href'); });
const htmlContent = (main?.innerHTML || '').trim();
waiverScroll.innerHTML = htmlContent || '<p>EAPS Waiver &amp; Participation Agreement. Please review the posted waiver page before acknowledging.</p>';
} catch (_) {
waiverScroll.innerHTML = '<p>EAPS Waiver &amp; Participation Agreement. Please review the posted waiver page before acknowledging.</p>';
}
requestAnimationFrame(() => {
waiverScrolled = waiverScroll.scrollHeight <= waiverScroll.clientHeight + 6;
if (waiverHelp) waiverHelp.textContent = '';
checkWaiverReady();
});
};
if (carouselPrev) carouselPrev.addEventListener('click', () => setActiveMedia(activeMediaIndex - 1));
if (carouselNext) carouselNext.addEventListener('click', () => setActiveMedia(activeMediaIndex + 1));
carouselDots.forEach(dot => dot.addEventListener('click', () => setActiveMedia(Number(dot.dataset.index || 0))));
let carouselWheelLock = 0;
if (imageCard) {
imageCard.addEventListener('wheel', event => {
const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY) && Math.abs(event.deltaX) > 14;
const shifted = event.shiftKey && Math.abs(event.deltaY) > 14;
if (!horizontal && !shifted) return;
event.preventDefault();
const now = Date.now();
if (now - carouselWheelLock < 420) return;
carouselWheelLock = now;
const delta = horizontal ? event.deltaX : event.deltaY;
setActiveMedia(activeMediaIndex + (delta > 0 ? 1 : -1));
}, { passive: false });
let swipeStartX = 0;
let swipeStartY = 0;
let swipeTracking = false;
let swipeMoved = false;
const startSwipe = touch => {
if (!touch || (config.media || []).length < 2) return;
swipeStartX = touch.clientX;
swipeStartY = touch.clientY;
swipeTracking = true;
swipeMoved = false;
};
const moveSwipe = (touch, event) => {
if (!swipeTracking || !touch) return;
const dx = touch.clientX - swipeStartX;
const dy = touch.clientY - swipeStartY;
if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.2) {
swipeMoved = true;
event.preventDefault();
}
};
const finishSwipe = touch => {
if (!swipeTracking || !touch) return;
const dx = touch.clientX - swipeStartX;
const dy = touch.clientY - swipeStartY;
swipeTracking = false;
if (!swipeMoved && Math.abs(dx) < 36) return;
if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.15) return;
setActiveMedia(activeMediaIndex + (dx < 0 ? 1 : -1));
};
imageCard.addEventListener('touchstart', event => startSwipe(event.touches[0]), { passive: true });
imageCard.addEventListener('touchmove', event => moveSwipe(event.touches[0], event), { passive: false });
imageCard.addEventListener('touchend', event => finishSwipe(event.changedTouches[0]), { passive: true });
imageCard.addEventListener('touchcancel', () => { swipeTracking = false; }, { passive: true });
if (mainImage) mainImage.addEventListener('dragstart', event => event.preventDefault());
}
setActiveMedia(0);
if (openSessions && sessionModal) {
openSessions.addEventListener('click', event => {
event.stopPropagation();
sessionModal.hidden ? openModal(sessionModal) : closeModal(sessionModal);
});
sessionModal.addEventListener('click', event => event.stopPropagation());
document.addEventListener('click', () => { if (!sessionModal.hidden && !inlineSessionMode()) closeModal(sessionModal); });
root.querySelectorAll('[data-rb-close-sessions]').forEach(el => el.addEventListener('click', () => closeModal(sessionModal)));
}
if (applySessions && sessionModal) applySessions.addEventListener('click', () => { updateSummary(); closeModal(sessionModal); setStatus(''); });
if (dateInput || dateSelect) {
const today = new Date();
if (dateInput) {
dateInput.min = toDateValue(today);
dateInput.max = toDateValue(addDays(today, 180));
}
const loadSelectedDate = async value => {
if (!config.recurringMode || !dateInput) return;
dateInput.value = value || '';
selectedIds.clear();
calendarPicked = !!dateInput.value;
setStatus(dateInput.value ? 'Loading times for that date...' : (config.freeHold ? 'Loading dates...' : 'Loading next sessions...'));
try {
await fetchFrames();
renderSessions();
updateSummary();
setStatus('');
} catch (err) {
sessions = [];
renderSessions();
updateSummary();
setStatus(err.message || 'Unable to load sessions for that date.', 'error');
}
};
dateInput?.addEventListener('change', () => loadSelectedDate(dateInput.value));
dateSelect?.addEventListener('change', () => loadSelectedDate(dateSelect.value));
calendarControl?.addEventListener('click', openDatePicker);
sessionList?.addEventListener('click', event => {
if (event.target.closest('[data-rb-calendar-card]')) openDatePicker(event);
});
window.addEventListener('resize', positionDateControl, { passive: true });
sessionList?.addEventListener('scroll', positionDateControl, { passive: true });
}
if (learnLink) learnLink.addEventListener('click', scrollToLearnPanel);
if (fhGroups) {
fhGroups.addEventListener('click', async event => {
const btn = event.target.closest('[data-rb-fh-variant]');
if (!btn || btn.disabled) return;
selectedFhVariantId = String(btn.dataset.rbFhVariant);
fhGroups.querySelectorAll('[data-rb-fh-variant]').forEach(el => el.setAttribute('aria-pressed', el === btn ? 'true' : 'false'));
selectedIds.clear();
if (dateInput) dateInput.value = '';
if (dateSelect) dateSelect.value = '';
calendarPicked = false;
setStatus('Loading dates for that group size...');
try {
await fetchFrames();
renderSessions();
updateSummary();
setStatus('');
} catch (err) {
sessions = [];
renderSessions();
updateSummary();
setStatus(err.message || 'Unable to refresh availability.', 'error');
}
});
}
if (minus) minus.addEventListener('click', () => { quantity -= 1; updateSummary(); });
if (plus) plus.addEventListener('click', () => { quantity += 1; updateSummary(); });
if (policyAccept) policyAccept.addEventListener('change', () => { setStatus(''); updateSummary(); });
if (shipCheckbox) shipCheckbox.addEventListener('change', () => setStatus(''));
form.addEventListener('input', event => { if (event.target.matches('input, select, textarea')) syncActionButtons(); }, true);
form.addEventListener('change', event => { if (event.target.matches('input, select, textarea')) syncActionButtons(); }, true);
if (eventWaitlistName) eventWaitlistName.addEventListener('input', () => { setStatus(''); updateSummary(); });
if (eventWaitlistEmail) eventWaitlistEmail.addEventListener('input', () => { setStatus(''); updateSummary(); });
if (eventWaitlistPhone) eventWaitlistPhone.addEventListener('input', () => { setStatus(''); updateSummary(); });
const openWaiver = root.querySelector('[data-rb-open-waiver]');
if (openWaiver) {
openWaiver.addEventListener('click', async () => {
await loadWaiver();
openModal(waiverModal);
waiverScroll.focus();
});
}
root.querySelectorAll('[data-rb-close-waiver]').forEach(el => el.addEventListener('click', () => closeModal(waiverModal)));
if (waiverScroll) waiverScroll.addEventListener('scroll', () => {
if (waiverScroll.scrollTop + waiverScroll.clientHeight >= waiverScroll.scrollHeight - 8) {
waiverScrolled = true;
if (waiverHelp) waiverHelp.textContent = '';
checkWaiverReady();
}
});
if (waiverName) {
waiverName.addEventListener('input', checkWaiverReady);
waiverName.addEventListener('focus', () => {
setTimeout(() => waiverName.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }), 80);
});
}
if (waiverSubmit) waiverSubmit.addEventListener('click', () => {
if (waiverSubmit.disabled) return;
waiverAccepted = { name: waiverName.value.trim(), timestamp: new Date().toISOString() };
waiverStatus.textContent = kidMode() ? `Waiver accepted by parent/guardian ${waiverAccepted.name}.` : `Waiver accepted by ${waiverAccepted.name}.`;
waiverStatus.dataset.accepted = 'true';
closeModal(waiverModal);
setStatus('');
syncActionButtons();
});
document.addEventListener('keydown', event => {
if (event.key !== 'Escape') return;
if (sessionModal && !sessionModal.hidden && !inlineSessionMode()) closeModal(sessionModal);
if (!waiverModal.hidden) closeModal(waiverModal);
});
const runReservation = async (destination) => {
setStatus('');
try {
const { selected, people } = validate();
const waitlisted = waitlistSelections(selected);
const reservable = reservableSelections(selected);
const waitlistOnly = waitlisted.length > 0 && reservable.length === 0;
const mixedMode = waitlisted.length > 0 && reservable.length > 0;
submit.disabled = true;
if (buynow) buynow.disabled = true;
if (waitlistOnly) {
submit.textContent = waitlisted.length > 1 ? 'Joining the waitlists…' : 'Joining the waitlist…';
await joinWaitlist(waitlisted, people);
setStatus(waitlisted.length > 1 ? 'You are on the waitlists. EAPS will reach out if spots open.' : 'You are on the waitlist. EAPS will reach out if a spot opens.', 'ok');
updateSummary();
return;
}
submit.textContent = mixedMode ? 'Checking the calendar…' : 'Checking the calendar…';
if (config.freeHold) {
submit.textContent = 'Reserving…';
const booking = await createDirectBooking(reservable, people);
submit.textContent = 'Reserved';
showFreeHoldConfirmation(reservable, people);
return;
}
const cartToken = await getCartToken();
const reservation = await createReservation(cartToken, reservable);
submit.textContent = mixedMode ? 'Adding reservation and waitlist…' : (destination === '/checkout' ? 'Going to checkout…' : 'Adding to cart…');
await addToCart(reservation, cartToken, reservable, people);
if (waitlisted.length) await joinWaitlist(waitlisted, people);
setStatus(mixedMode ? 'Reservation added and waitlist joined. Taking you to cart...' : (destination === '/checkout' ? 'Reserved. Taking you to checkout...' : 'Reserved. Taking you to cart...'), 'ok');
window.location.href = mixedMode ? '/cart' : destination;
} catch (err) {
setStatus(err.message || 'Something went wrong. Please call the studio and we can help finish the reservation.', 'error');
updateSummary();
}
};
form.addEventListener('submit', event => {
event.preventDefault();
runReservation('/cart');
});
if (buynow) buynow.addEventListener('click', () => runReservation('/checkout'));
(async () => {
try {
await fetchBtaProduct();
await fetchFrames();
renderSessions();
updateSummary();
} catch (err) {
setStatus(err.message || 'Unable to load availability.', 'error');
sessions = [];
renderSessions();
updateSummary();
submit.disabled = true;
submit.textContent = 'Call to reserve';
if (sessionTitle) sessionTitle.textContent = 'Availability unavailable';
if (sessionMeta) sessionMeta.textContent = config.freeHold ? 'Try another date or group size.' : (config.recurringMode ? 'Pick another date or studio.' : 'Call the studio and we can help finish the reservation.');
if (availabilityNote) availabilityNote.textContent = 'Unavailable';
}
})();
renderPeople();
updateSummary();
};
const queue = window.__rbInit || [];
window.__rbInit = { push: init };
queue.forEach(init);
})();
